import React from 'react';
import moment from 'moment';
import { fromJS, List, Map } from 'immutable';
import { compose, is, mergeDeepRight, keys, contains, find,omit, reduceWhile, startsWith, replace,pick } from 'ramda';

import api from '@synergycms_core/utils/api';
import Form from '@synergycms_core/components/generic/Form';
import InputField from '@synergycms_core/components/generic/Form/InputField.jsx';
import CheckboxField from '@synergycms_core/components/generic/Form/CheckboxField.jsx';
import TextAreaField from '@synergycms_core/components/generic/Form/TextAreaField.jsx';
import InputNotify from '@synergycms_core/components/generic/Form/InputNotify';
import styleFile from './CustomerForm.js';
import hoursSelectStyle from './hoursSelectStyles.js';
import ButtonSubmit from '@synergycms_core/components/generic/Form/ButtonSubmit';
import LoyaltyLogin from '../../components/functional/Loyalty/LoyaltyLogin.jsx';
import AvailMainSideSummary from '../../components/functional/AvailMainSideSummary/AvailMainSideSummary.jsx';
import { AR_STATES, PCI_URL, PROPERTY_MANAGEMENT_GROUP } from '../../config/constants';
import {DOCUMENT_TYPES} from '@synergycms_core/config/constants';
import PciFrame from '../../components/functional/CustomerForm/PciFrame';
import RoomPreferences from '../../components/functional/CustomerForm/RoomPreferences';
import SelectCountry from '@synergycms_core/components/functional/CustomerForm/SelectCountry.jsx';
import SelectField from '@synergycms_core/components/generic/Form/SelectField.jsx';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import connect from 'react-redux/es/connect/connect';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { cleanHotelPreferences, getPrepaymentText, getReservationTotals, addScripts, decodeBlackEmail } from '../../utils';
import { hashSpliter } from '@synergycms_core/utils';
import Price from '@synergycms_core/components/generic/Price';
import { Button, RichText, Image } from '@synergycms_core/components/generic/';
import EPGClass from '@synergycms_core/utils/tpv/epg';
import SibsFrame from '../../components/functional/CustomerForm/SibsFrame';
import RedsysClass from '@synergycms_core/utils/tpv/redsys';
import XpayClass from '@synergycms_core/utils/tpv/xPay';
import SibsClass from '@synergycms_core/utils/tpv/sibs';
import PaycometClass from '@synergycms_core/utils/tpv/paycomet';
import CardnetClass from '@synergycms_core/utils/tpv/cardnet';
import StripeClass from '@synergycms_core/utils/tpv/stripe';
import AmazonClass from '../../utils/tpv/amazon';
import PayPalClass from '../../utils/tpv/paypal';
import SelectPayForm from '../../components/functional/CustomerForm/SelectPayform.jsx';
import actions from '../../store/actions';
import { getPenalties } from '../../utils/penalties';
import SearchOptions from '../../components/functional/SearchOptions';
import { hasCancellationFeesIn15Days } from '../../store/customer/reservation/reservationUtils';
import {
  EquivalentPrice,
  OldPrice,
  TaxIncluded,
  LoadingFragment,
  LoadingConfirmation,
  EPGContainer
} from '../../components/functional/CustomerForm/SmallComponents';
import PayPalContainer from '../../components/functional/CustomerForm/PayPalContainer.jsx';
import AmazonPayButton from '../../components/functional/CustomerForm/AmazonPayButton.jsx';
import PromotionCodeForm from '../../components/functional/CustomerForm/PromotionCodeForm';
import RadioGroupField from '@synergycms_core/components/generic/Form/RadioGroupField';
import loggerGetter from '@synergycms_core/utils/logger';
import AmazonPayWidget from '../../components/functional/CustomerForm/AmazonPayWidget.jsx';
import PolicyModalGroup from '../../components/functional/CustomerForm/PolicyModalGroup.jsx';
import LoyaltyPoliciesChecks from '../../components/functional/Loyalty/LoyaltyPoliciesChecks.jsx';
import { apiGetter } from '@synergycms_core/utils/api';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import { CSSTransition } from 'react-transition-group';
import LoyaltyPaymentPoints from '../../components/functional/Loyalty/LoyaltyPaymentPoints';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import StripeFrame from '../../components/functional/CustomerForm/StripeFrame';
import format from 'string-template';
import LoyaltyUserInfo from '../../components/functional/Loyalty/LoyaltyUserInfo.jsx';
import {STAR_TRAVELER_CODE, FIDELTOUR_CODE} from '@synergycms_app/store/customer/loyaltyActions';
import LoyaltyUserPoints from '../../components/functional/Loyalty/LoyaltyUserPoints.jsx';
import { get } from 'synergycms_core/src/utils/utils.js';
import TooltipWrapper from '@synergycms_core/components/generic/TooltipWrapper';
import LoyaltyForm from '../../components/functional/Loyalty/FidelTour/LoyaltyForm';
import { showPopover } from '@synergycms_core/components/providers/popoverProvider';


const { customer: customerActions } = actions;

const payFormsWithPCI = ['htl', 'ccg'];
const customerPatchFields = [
  'name',
  'surname',
  'email',
  'phone',
  'hours_arrival',
  'country',
  'state',
  'nationality',
  'document_type',
  'country_iso_code',
  'notes',
  'GDPR_accepted',
  'GDPR_loyalty',
  'check_loyalty',
  'required_policies',
  'tax_number',
  'travel_reason',
  'td',
  'tds',
  'tdd',
  'tdf',
  'td_history',
  'POS',
  'chosen_currency',
  'trv_reference',
  'card_holder',
  'travelclub_card',
  'allow_loyalty_point_redemption',
  'addressLine1',
  'customerCountry',
  'customerCity',
  'postCode',
  'booker_name',
  'booker_surname',
  'booker_email',
];
const bookingPatchFields = customerPatchFields.slice().concat('status', 'payment');

const ArrivingHoursOptions = (hours, classes) => props => {
  return (
    <div {...props.innerProps} className={classes.textContainer}>
      <div className={classes.nameType}>
      </div>
      <div className={[classes.padded, classes.tipeRoom, 'capitalize'].join(' ')}>
        <RichText innerStyle={['roboto13Black']} text={props.data.label} translate={true} ucFirst={true} />
      </div>
    </div>
  );
};

const CustomerForm = class CustomerForm extends React.Component {
  static displayName = 'CustomerForm';
  /** @type {boolean | string} */
  tpvEnabled = false;
  /** @type {boolean} */
  payPalEnabled = false;
  /** @type {boolean} */
  validForm = false;
  /** @type {boolean} */
  amazonPayEnabled = false;
  /** @type {AMAZON} */
  Amazon = null;
  /** @type {PAYPAL} */
  PayPal = null;
  /** @type {EPGClass|null } */
  EPG = null;
  /** @type {string | null} */
  paymentToken = null;
  /** @type {string | null} */
  selectedCountry = null;
  /** @type {string} */
  formID = 'customerBookingForm';
  /** @type {array} */
  errors = [];
  /** @type {number} */
  retriesTpv = 0;
  /** @type {boolean} */
  returnFromSuccessCof = false;
  /** @type {string} */
  tpvBizumRedsys = '0';
  /** @type {string} */
  GtmId = 'td-d3-confirm-form-00';
  /** @type {boolean} */
  travelClubCard = false;
  /** @type {boolean} */
  travelClubEnabled = false;
  /** @type {boolean} */
  stripeTokenRetrieved = false;

  constructor(props) {
    super(props);
    const {
      blocks,
      reservation,
      countries,
      tpvPaymentStatus,
      showConfirmation,
      showErrorNotification,
      hotel,
      setReservationPayed,
      triggerEvent,
      incrementPaymentRetry,
      hideAvailEngine,
      referer,
      managementGroupID,
      langCode,
      setStripeToken,
      stripeTokenStatus,
      loyaltyUser,
      loyaltyType,
      loyaltyRoomsAvail,
      loyaltySelected,
      forceOP,
      customerCountry
    } = this.props.config;

    hideAvailEngine();
    const UserLoggedST = !!loyaltyUser && loyaltyType === STAR_TRAVELER_CODE;

    this.travelClubEnabled = hotel.getIn(['travelclub'],false);
    this.tpvEnabled = !(hotel.getIn(['tpv_only_gift_voucher'], false)) ? hotel.getIn(['tpv', 'name'], false) : false;

    this.tpvParams = hotel.getIn(['tpv', 'tpv_params'], false);
    this.tpvEnabledType = this.tpvEnabled === 'Redsys' && this.tpvParams.find(p => p.get('code') === 'Ds_Merchant_type', Map()).get('value', '');
    this.payPalEnabled = hotel.getIn(['paypal', 'name'], false);
    this.amazonPayEnabled = hotel.getIn(['amazon_pay', 'name'], false);
    const redsysBizumParam = this.tpvEnabled === 'Redsys' && this.tpvParams.find(p => p.get('code') === 'bizum_enabled', Map());
    this.tpvBizumRedsys = redsysBizumParam ? redsysBizumParam.get('value', '') : '0';

    const enableToggleForm = !!loyaltyUser;
    const showUserInfo = enableToggleForm;
    const showEditUserFields = !enableToggleForm;

    const getArea = (key) => {
      return countries.find(country => country.get('alpha2') === reservation.getIn(['customer', key], false)) ||
      countries.find(country => country.get('alpha2') === customerCountry) ||
      ( loyaltyUser && countries.find(country => country.get('alpha2') === loyaltyUser.getIn(['nationality'], false))) ||
      countries.find(country => country.get('alpha2') === this.props.config.defaultCountryCode) ||
      countries.find(country => country.get('alpha2') === 'ES');
    }

    this.repeatedBookingPromise = false;
    this.defaultCountry = this.selectedCountry = getArea("country");
    const nationality = this.defaultNationality = getArea("nationality");
    this.selectedPhone = this.getPhoneFromLoyaltyUser(this.selectedCountry, loyaltyUser);

    const showIdentifierDocument = !!loyaltyRoomsAvail && loyaltySelected && !loyaltyUser && DOCUMENT_TYPES[nationality.get("alpha2")];

    //Hora de llegada
    const content = this.props.content
    const arrivingHours = [
      {"value": ''},
      {"value": "08:00 - 09:00"},
      {"value": "09:00 - 10:00"},
      {"value": "10:00 - 11:00"},
      {"value": "11:00 - 12:00"},
      {"value": "12:00 - 13:00"},
      {"value": "13:00 - 14:00"},
      {"value": "14:00 - 15:00"},
      {"value": "15:00 - 16:00"},
      {"value": "16:00 - 17:00"},
      {"value": "17:00 - 18:00"},
      {"value": "18:00 - 19:00"},
      {"value": "19:00 - 20:00"},
      {"value": "20:00 - 21:00"},
      {"value": "21:00 - 22:00"},
      {"value": "22:00 - 23:00"},
      {"value": "23:00 - 00:00"},
      {"value": "00:00 - 01:00"},
      {"value": "01:00 - 02:00"},
    ];
    this.arrivingHoursList = List(arrivingHours.map( hour => {
      const label = hour.value ? content.t(hour.value) : content.t("_%no lo sé%_")
      return {"value": hour.value, "label": label }
    }))
    this.defaultArrivalHour = this.arrivingHoursList.find(h => h.value === reservation.getIn(['customer', 'hours_arrival'], '' ))

    if (this.tpvEnabled === 'EPG') {
      this.EPG = new EPGClass(
        process.env.NODE_ENV === 'production' ? 'prod' : 'stage',
        reservation,
        hotel,
        tpvPaymentStatus,
        setReservationPayed,
        showConfirmation,
        showErrorNotification
      );
    }
    if (this.amazonPayEnabled) {
      this.Amazon = new AmazonClass(reservation, incrementPaymentRetry, tpvPaymentStatus, showErrorNotification);
    }
    if (this.payPalEnabled) {
      this.PayPal = new PayPalClass(reservation, hotel.get('id'), incrementPaymentRetry, tpvPaymentStatus, showErrorNotification);
    }
    if (this.tpvEnabled === 'SIBS') {
      this.SIBS = new SibsClass(
        (process.env.NODE_ENV !== 'production'),
        reservation,
        hotel,
        tpvPaymentStatus,
        showConfirmation,
        showErrorNotification
      );
    }
    if (this.tpvEnabled === 'Redsys') {
      this.REDSYS = new RedsysClass(
        process.env.NODE_ENV === 'production' ? 'prod' : 'stage',
        reservation,
        hotel,
        tpvPaymentStatus,
        setReservationPayed,
        showConfirmation,
        showErrorNotification
      );
    }
    if (this.tpvEnabled === 'Stripe') {
      this.STRIPE = new StripeClass(
        process.env.NODE_ENV === 'production' ? 'prod' : 'stage',
        reservation,
        hotel,
        tpvPaymentStatus,
        setReservationPayed,
        showConfirmation,
        showErrorNotification
      );

    }
    if (this.tpvEnabled === 'Paycomet') {
      this.PAYCOMET = new PaycometClass(
        process.env.NODE_ENV === 'production' ? 'prod' : 'stage',
        reservation,
        hotel,
        tpvPaymentStatus,
        setReservationPayed,
        showConfirmation,
        showErrorNotification
      );
    }
    if (this.tpvEnabled === 'xPay') {
      this.XPAY = new XpayClass(
        process.env.NODE_ENV === 'production' ? 'prod' : 'stage',
        reservation,
        hotel,
        tpvPaymentStatus,
        setReservationPayed,
        showConfirmation,
        showErrorNotification
      );
    }
    if (this.tpvEnabled === 'Cardnet') {
      this.CARDNET = new CardnetClass(
        process.env.NODE_ENV === 'production' ? 'prod' : 'stage',
        reservation,
        hotel,
        tpvPaymentStatus,
        setReservationPayed,
        showConfirmation,
        showErrorNotification
      );
    }

    triggerEvent('customer_data');

    const showBookerGuestForm =
      reservation.getIn(['customer', 'guest_booker','booker_name'], false) ||
      reservation.getIn(['customer', 'guest_booker','booker_name'], false) ||
      reservation.getIn(['customer', 'guest_booker','booker_email'], false)

    this.state = {
      showIdentifierDocument,
      showUserInfo,
      showEditUserFields,
      showRoomPreferences:
        blocks &&
        blocks.reduce((showRoomPreferences, block, index) => {
          showRoomPreferences[block.get('idx')] = index === 0;
          return showRoomPreferences;
        }, {}),
      payFormSelected: forceOP ? 'op' :'htl',
      prepayTokenEPG: false,
      showCardValidationError: tpvPaymentStatus === 'COF:ERROR',
      repeatedBooking: {
        status: 'pending',
        email: null,
        clientAccepted: null,
        submited: false
      },
      editCommentary: false,
      showPromotionalBox: false,
      showLoyaltyPaymentPoints: false,
      showTravelClub: true,
      heightContainer: 0,
      heightRef: null,
      travelclubError : {
        error : false,
        text: false,
        validCheck: false
      },
      cardHolderError: {
        error : false,
        text: false
      },
      showBookerGuestForm: showBookerGuestForm,
    };

    const paymentToken = reservation && reservation.getIn(['payment', 'token'], false);

    if (typeof paymentToken === 'string') {
      this.paymentToken = paymentToken;
      if (tpvPaymentStatus === 'COF:OK') {
        this.returnFromSuccessCof = true;
      }
    }

    if(this.tpvEnabled === 'Stripe' && stripeTokenStatus) {
      let status = atob(stripeTokenStatus);
      let stripeStatus = status.split(':');
      let tokenStatus = stripeStatus[1] || false;
      let tokenId = stripeStatus[0] || false;
      if( tokenStatus && tokenId) {
        let stripeIntent = tokenId;
        if (typeof tokenStatus === 'string'  && tokenStatus === 'succeeded') {
          this.paymentToken = stripeIntent;
          if (tpvPaymentStatus === 'COF:OK') {
            this.returnFromSuccessCof = true;
          }
        }
      }
    }
    if (this.tpvEnabled === 'Stripe' && !this.paymentToken && !this.returnFromSuccessCof) {
      const pms = hotel && hotel.get('pms');
      const penalties = getPenalties(reservation, managementGroupID === PROPERTY_MANAGEMENT_GROUP, pms, langCode);
      const notRefundable = penalties[0].nr || penalties[0].flexible || false;
      const requiredPrepayment = this.props.config.requiredPrepayment;
      const fullFreeReservation = this.props.config.fullFreeReservation;


      this.STRIPE.initialize(
        hotel,
        reservation,
        this.selectedCountry.get('alpha2'),
        this.props.config.langCode.toLowerCase(),
        this.formID,
        this.props.config.currentCurrencyCode,
        showErrorNotification,
        notRefundable ? 'op' : 'htl'
      );
      if(!notRefundable ) {
        const code = hotel.get('code');
        const tracking = reservation.get('tracking_id');
        let url =   document.URL;
        let currency =   this.props.config.currentCurrencyCode;
        let  langCode = this.props.config.langCode.toLowerCase();
        let requiredPrepaymentCalc = 0;
        if (requiredPrepayment > 0 && !fullFreeReservation && !notRefundable ) {
          requiredPrepaymentCalc = requiredPrepayment;

        } else {
          requiredPrepaymentCalc = 0;
        }
        setStripeToken(currency, langCode, requiredPrepaymentCalc, code, tracking, url, true);
        this.stripeTokenRetrieved = true;
      }
    }
    const scripts = hotel.getIn(['extended_scripts'], undefined);
    if (scripts && scripts.size > 0 && referer) {
      addScripts(hotel, referer, 'customer');
    }
    window.addEventListener('message', this.overrideHeight, false);
    if (this.tpvEnabled === 'EPG') {
      window.addEventListener('message', this.EPG.receiveMessage, false);
    }

    if(UserLoggedST) {
      this.tpvEnabled = false;
    }
  }

  componentWillUnmount = () => {
    window.removeEventListener('message', this.overrideHeight, false);
    if (this.tpvEnabled === 'EPG') {
      window.removeEventListener('message', this.EPG.receiveMessage, false);
    }
  };

  validateFields = (inputList) => {
    return reduceWhile(
      (validationResult) => {
        return validationResult;
      },
      (validationResult, key) => {
        return !inputList[key].validations.length || get(['validation', 'valid'], inputList[key]) === true;
      },
      true,
      Object.keys(inputList));
  };

  getPhoneFromLoyaltyUser = (selectedCountry, loyaltyUser) => {
    const loyaltyType = this.props.config.loyaltyType
    switch(loyaltyType){
      case STAR_TRAVELER_CODE:
        const phone = loyaltyUser?.get("phone") && replace("+","",loyaltyUser.get("phone"));
        if(phone && selectedCountry?.get('phone_prefix') && startsWith(selectedCountry.get('phone_prefix',''), phone)) {
          return replace(selectedCountry.get('phone_prefix'),"", phone);
        }
        return "";
      case FIDELTOUR_CODE:
        return loyaltyUser && loyaltyUser.get("phone");
      default:
        return "";
    }
  }

  componentWillReceiveProps(nextProps) {

    if (this.props.config.loyaltyUser !== nextProps.config.loyaltyUser) {

      const { loyaltyUser,countries } = nextProps.config;
      const {inputList, onGlobalChange} = this.stateRetriever();
      if(inputList && loyaltyUser) {
        const selectedCountry = countries.find(country => country.get('alpha2') === loyaltyUser.getIn(['nationality'], false));
        if(selectedCountry) {
          this.selectedCountry = selectedCountry;
          this.selectedPhone = this.getPhoneFromLoyaltyUser(this.selectedCountry, loyaltyUser);
        }

        const fields = ["name", "surname", "email", "repeatEmail", "phone", "country"];

        Promise.props({
          "name": inputList["name"].onChange(loyaltyUser.get("name"),true),
          "surname": inputList["surname"].onChange(loyaltyUser.get("surname"),true),
          "email": inputList["email"].onChange(loyaltyUser.get("email"),true),
          "repeatEmail": inputList["repeatEmail"].onChange(loyaltyUser.get("email"),true),
          "phone": inputList["phone"].onChange(this.selectedPhone, true),
          "country": inputList["country"].onChange(this.selectedCountry, true)
        }).then(()=> {
          onGlobalChange(fields, null, true).then((inputList)=>{
              const isValid = this.validateFields(pick(fields, inputList));
              const enableToggleForm = isValid && !!loyaltyUser;
              const showUserInfo = enableToggleForm;
              const showEditUserFields = !enableToggleForm;
              this.setState({ showUserInfo, showEditUserFields });
          });
            //});
        });
      } else {
        const enableToggleForm =!!loyaltyUser;
        const showUserInfo = enableToggleForm;
        const showEditUserFields = !enableToggleForm;
        this.setState({ showUserInfo, showEditUserFields });
      }
    }
  }

  validateRepeatBooking = (valid, inputList, reservation) => {
    const { repeatedBooking } = this.state;
    const { hotel } = this.props.config;

    if (
      !this.repeatedBookingPromise && (
        (repeatedBooking.email !== inputList['repeatEmail'].value && inputList['repeatEmail'].validation.valid) ||
        repeatedBooking.status === 'failed'
      )
    ) {
      this.repeatedBookingPromise = new Promise(resolve => {
        const extraHeaders = [
          { Authorization: 'Basic ' + btoa(reservation.get('tracking_id') + ':' + reservation.get('pin_code')) }
        ];
        api
          .get('cms/check_reservation_duplicated/' + reservation.get('tracking_id'), {}, hotel.get('id'), extraHeaders)
          .then(result => {
            this.setState(
              state => {
                return {
                  repeatedBooking: {
                    ...state.repeatedBooking,
                    status: result.duplicated ? 'repeated' : 'accepted',
                    email: inputList['email'].value,
                    clientAccepted: null,
                    submited: false
                  }
                };
              },
              () => resolve()
            );
          })
          .catch(result => {
            this.setState(
              state => {
                return {
                  repeatedBooking: {
                    ...state.repeatedBooking,
                    status: 'failed',
                    email: inputList['email'].value,
                    clientAccepted: null
                  }
                };
              },
              () => resolve()
            );
          });
      });
      return this.repeatedBookingPromise;
    }
    return Promise.resolve();
  };

  validateTravelclubCard = (valid, inputList, reservation) => {

    const { hotel } = this.props.config;
    let error = false;
    let text = false;
    let validCheck = false;
    if (
        inputList['travelclub_card'] && inputList['travelclub_card']['value'] !== ""
    ) {

      const travelclubCard = inputList['travelclub_card']['value'];
      const reg = /^\d+$/;
      let isNumber = reg.test(String(travelclubCard).toLowerCase());
      if(travelclubCard.length !== 0 && (travelclubCard.length !== 10 || !isNumber)) {
        error = true;
        validCheck = false;
        if(!isNumber) {
          text = '_%el campo tiene que ser un número%_';
        } else {
          text = '_%el campo debe tener 10 dígitos%_';
        }
      } else {
        this.validateTravelClubPromise = new Promise(resolve => {
          const extraHeaders = [
            { Authorization: 'Basic ' + btoa(reservation.get('tracking_id') + ':' + reservation.get('pin_code')) }
          ];
          api
            .post('travelclub_validation', {
              'card': travelclubCard,
              'card_prefix': '6015470',
              'tracking': reservation.get('tracking_id')
            }, hotel.get('id'), extraHeaders)
            .then(result => {
              this.travelClubCard = result ? true : false;
              this.setState(
                state => {
                  return {
                    travelclubError: {
                      ...state.travelclubError,
                      error: result ? false : true,
                      text: result? false : '_%tarjeta no válida%_',
                      validCheck: result
                    }
                  };
                }
              );
            })
            .catch(result => {
              this.travelClubCard = false;
              this.setState(
                state => {
                  return {
                    travelclubError: {
                      ...state.travelclubError,
                      error:  true,
                      text:  '_%tarjeta no válida%_',
                      validCheck: false
                    }
                  };
                }
              );
            });
        });
        return this.validateTravelClubPromise;
      }
    }
    this.setState(
      state => {
        return {
          travelclubError: {
            ...state.travelclubError,
            error: error,
            text: text,
            validCheck: validCheck
          }
        };
      }
    );
    return Promise.resolve();
  };

  validateCardHolder = (valid, inputList) => {

    let error = false;
    let text = false;
    if (
       this.state.payFormSelected === 'htl' && this.tpvEnabled === 'Stripe'
    ) {

      const cardHolder = inputList['card_holder']['value'];

      if(cardHolder.length === 0 ) {
        error = true;
        text = format(this.props.content.t('_%el campo {field} es obligatorio%_'),
          { field: this.props.content.t('_%nombre del titular%_') }
        );
      }
    }
    this.setState(
      state => {
        return {
          cardHolderError: {
            ...state.cardHolderError,
            error: error,
            text: text
          }
        };
      }
    );
    return Promise.resolve();
  };

  componentDidMount(prevProps, prevState, snapshot) {
    //window.frontLoader.render("login-front", { type:"availCustomerForm" });
    //window.frontLoader.renderLogin("login-front", { type:"availCustomerForm" });
    if (this.state.showCardValidationError) {
      this.refs['card_validation_error'].scrollIntoView();
    }

    this.retriesTpv = 0;
    const logger = loggerGetter();
    window.onerror = (message, url, line, column, error) => {
      let errorMessage = '';
      if (error) {
        errorMessage = typeof error.stack !== 'undefined' ? error.stack : error.toString();
      }
      errorMessage += ' -> ' + navigator.userAgent;

      logger.addLine(message, errorMessage);
      this.errors.push({
        url: window.document.location.href,
        message: message,
        error: errorMessage
      });
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      hotel,
      loyaltyUser,
      loyaltyType,
      reservation,
      reservationPaid,
      langCode,
      showErrorNotification,
      amountToPay,
      currentCurrencyCode,

    } = this.props.config;

    const UserLoggedST = !!loyaltyUser && loyaltyType === STAR_TRAVELER_CODE;
    const needsSetTPV = !this.tpvEnabled && !(hotel.getIn(['tpv_only_gift_voucher'], false)) && !UserLoggedST && hotel.getIn(['tpv', 'name'], false);
    const needsUnsetTPV = this.tpvEnabled && UserLoggedST;
    if(needsSetTPV) {
      this.tpvEnabled = hotel.getIn(['tpv', 'name']);
    }
    if(needsUnsetTPV) {
      this.tpvEnabled = false
    }


    if (this.tpvEnabled) {
      switch (this.tpvEnabled) {
        case 'EPG':
          if (needsSetTPV || (prevProps && prevProps.config.reservationPaid && !reservationPaid)) {
            this.EPG.initialize(
              hotel,
              reservation,
              this.selectedCountry.get('alpha2'),
              langCode.toLowerCase(),
              this.formID,
              showErrorNotification,
              this.setStateEPGPrepaymentToken,
              this.checkTpvContainer
            );
          }
          break;
        case 'Redsys':
          if (prevProps && prevProps.config.amountToPay !== amountToPay) {
            this.REDSYS.initialize(
              hotel,
              reservation,
              this.selectedCountry.get('alpha2'),
              langCode.toLowerCase(),
              this.formID,
              showErrorNotification,
              this.state.payFormSelected
            );
          }
          break;
        case 'Paycomet':
          if (prevProps && prevProps.config.amountToPay !== amountToPay) {
            this.PAYCOMET.initialize(
              hotel,
              reservation,
              this.selectedCountry.get('alpha2'),
              langCode.toLowerCase(),
              this.formID,
              currentCurrencyCode,
              showErrorNotification
            );
          }
          break;
        case 'xPay':
          if (prevProps && prevProps.config.amountToPay !== amountToPay) {
            this.XPAY.initialize(
              hotel,
              reservation,
              this.selectedCountry.get('alpha2'),
              langCode.toLowerCase(),
              this.formID,
              currentCurrencyCode,
              showErrorNotification
            );
          }
          break;
        case 'Cardnet':
          if (prevProps && prevProps.config.amountToPay !== this.props.config.amountToPay) {
            this.CARDNET.initialize(
              this.props.config.hotel,
              this.props.config.reservation,
              this.props.config.currentCurrencyCode,
              this.props.config.showErrorNotification
            );
          }
          break;  
        case 'Stripe':
          if (prevProps && prevProps.config.amountToPay !== amountToPay) {
            if(this.state.payFormSelected === 'op') {
              this.STRIPE.initialize(
                hotel,
                reservation,
                this.selectedCountry.get('alpha2'),
                langCode.toLowerCase(),
                this.formID,
                currentCurrencyCode,
                showErrorNotification,
                this.state.payFormSelected
              );
            }
          }
          break;
        default:
          break;
      }
    }
    if (prevState.heightContainer === 'auto' && this.state.heightContainer !== 'auto') {
      this.setState({ heightContainer: '0px' });
    }
  }

  checkTpvContainer = () => {
    const { reservation, hotel, showErrorNotification } = this.props.config;

    setTimeout(() => {
      const failsAlert = 4;
      const stopRetries = 10;
      if (this.tpvEnabled === 'EPG') {
        const submitButtonwindow = document.querySelector('#' + this.EPG.submitButton);
        if (!submitButtonwindow) {
          this.retriesTpv++;
          if (this.retriesTpv <= stopRetries) {
            this.EPG.initialize(
              hotel,
              reservation,
              this.selectedCountry.get('alpha2'),
              this.props.config.langCode.toLowerCase(),
              this.formID,
              showErrorNotification,
              this.setStateEPGPrepaymentToken,
              this.checkTpvContainer
            );
          }
          if (this.retriesTpv === failsAlert) {
            let customError = '';
            if (typeof window.EPGJS === 'undefined') {
              customError += 'EPGJS NOT DEFINED; ';
            }
            if (typeof window.EPGJS_COMM === 'undefined') {
              customError += 'EPGJS_COMM NOT DEFINED; ';
            }
            if (typeof window.EPGJS_STYLE === 'undefined') {
              customError += 'EPGJS_STYLE NOT DEFINED; ';
            }
            if (!this.EPG.panInputLoaded) {
              customError += 'EPG PAN NOT LOADED; ';
            }
            const cashier = document.querySelector('#' + this.EPG.cashierContainer);
            this.errors.unshift({
              url: window.document.location.href,
              message: 'TPV EPG ' + failsAlert + ' fails on initialize with render cashier',
              error: customError + navigator.userAgent + (cashier ? '; HTML EPG: ' + cashier.innerHTML : '')
            });
            api.post('cms/send_avail_error', this.errors, hotel.get('id'));
          }
        } else {
          if (this.retriesTpv >= failsAlert) {
            this.errors.unshift({
              url: window.document.location.href,
              message: '<strong>SUCCESS</strong>: TPV EPG ' + failsAlert + ' fails but solved',
              error: ''
            });
            api.post('cms/send_avail_error', this.errors, hotel.get('id'));
          }
        }
      }
    }, 2000);
  };

  setStateEPGPrepaymentToken = prepayTokenEPG => {
    this.setState(state =>
      mergeDeepRight(state, {
        prepayTokenEPG: prepayTokenEPG
      })
    );
  };

  overrideHeight = e => {
    const message = e.data;
    if (e.origin === PCI_URL && message.indexOf('pci_iframe_with') !== -1) {
      let pciIframeHeight;
      [, pciIframeHeight] = message.split(':');
      pciIframeHeight = parseInt(pciIframeHeight, 10);
      if (!(pciIframeHeight === 0 && this.state.pciIframeHeight > 0)) {
        this.setState({
          pciIframeHeight: pciIframeHeight
        });
      }
    }
  };

  validateLoyaltyUser = (validForm, inputList, stateRetriever) => {
    const { manageLoading } = stateRetriever();
    const { reservation, triggerEvent, loyaltyRegister, loyaltyType, loyaltyUser, loyaltySelected } = this.props.config;

    if (!validForm) {
      const firstUnvalidKey = Object.keys(inputList).find(k => inputList[k].validation.valid === false);
      this.refs[firstUnvalidKey] && this.refs[firstUnvalidKey].scrollIntoView();
      window.scrollBy(0, -65);
      triggerEvent('confirm_error', 'required_fields');
      return false;
    }
    else if(loyaltySelected && FIDELTOUR_CODE === loyaltyType && !loyaltyUser) {

      manageLoading(true);

      const subscribed = inputList["GDPR_loyalty"] ? !inputList["GDPR_loyalty"]["value"] : reservation.getIn(['customer', 'check_loyalty'], false);
      const registerinputs = {
        "name": inputList["name"],
        "surname": inputList["surname"],
        "email": inputList["email"],
        "country": inputList["country"],
        "phone": inputList["phone"],
        "password": inputList["password"],
        "repeatPassword": inputList["repeatPassword"],
        "accept_conditions": inputList["required_policies"],
        "subscribed": subscribed
      }

      return loyaltyRegister(registerinputs).then((response) => {
        return this.validatePaymentForms(validForm, inputList, stateRetriever);
      }).catch((error) => {
        manageLoading(false);
        return false;
      });

    }
    else {
      return this.validatePaymentForms(validForm, inputList, stateRetriever);
    }
  }

  validatePaymentForms = (validForm, inputList, stateRetriever) => {
    const { manageLoading } = stateRetriever();
    const logger = loggerGetter();
    if (
      this.state.payFormSelected === 'htl' &&
      (!this.state.pciIframeHeight || parseInt(this.state.pciIframeHeight, 10) < 20)
    ) {
      logger.addLine('height pci error', navigator.userAgent).sendMail();
    }

    const {
      reservation,
      hotel,
      showTaxes,
      setReservationPayed,
      showConfirmation,
      hotelCurrencyCode,
      showErrorNotification,
      triggerEvent,
      reservationPaid,
      fullFreeReservation,
      amazonPayMerchantID,
      confirmBookingOnlyStore
    } = this.props.config;

    logger
      .sendOnTimeout()
      .process('run')
      .addLine('info reservation', reservation);

    const { status, clientAccepted } = this.state.repeatedBooking;
    // scroll to first unvalid
    if (!validForm) {
      logger.process('stop').clearLog();
      const firstUnvalidKey = Object.keys(inputList).find(k => inputList[k].validation.valid === false);
      this.refs[firstUnvalidKey] && this.refs[firstUnvalidKey].scrollIntoView();
      window.scrollBy(0, -65);
      triggerEvent('confirm_error', 'required_fields');
    } else {
      logger.addLine('Is valid form', '');
      triggerEvent('confirm_customer_data')
    }

    return this.validateRepeatBooking(validForm, inputList, reservation).then(() => {
      //const { repeatedBooking } = this.state;
      if (status === 'repeated' && !clientAccepted && this.state.payFormSelected !== 'paypal') {
        this.setState(state => {
          return {
            repeatedBooking: {
              ...state.repeatedBooking,
              submited: true,
              clientAccepted: null
            }
          };
        });
        window.scrollTo(0, 0);
        let resolve, reject;

        const promise = new Promise(function() {
          resolve = arguments[0];
          reject = arguments[1];
        });

        this.acceptedReapetedBookingPromise = { resolve, reject, promise };
      } else {
        this.acceptedReapetedBookingPromise = { promise: Promise.resolve() };
      }

      return this.acceptedReapetedBookingPromise.promise.then(() => {
          const { repeatedBooking } = this.state;
          if (contains(repeatedBooking.status, ['accepted', 'failed']) || repeatedBooking.clientAccepted || this.state.payFormSelected === 'paypal') {
            manageLoading(true);
            return new Promise((resolve, reject) => {
              logger.addLine('payment type', this.state.payFormSelected);
              if (reservationPaid || fullFreeReservation) {
                this.onSubmit(validForm, inputList, resolve, reject, false);
              } else {
                switch (this.state.payFormSelected) {
                  case 'op':
                  case 'bizum':

                    if (validForm) {
                      switch (this.tpvEnabled) {
                        case 'EPG':
                          this.EPG.validatePayment(this.onSubmit, validForm, inputList, resolve, reject);
                          break;
                        case 'SIBS':
                          // NOTE: SIBS online payment, works equal as hotel payment
                          if(validForm) {
                            const pciFrame = this.pciFrame;
                            this.receiveMessagePCIFunction = this.receiveMessagePCI(validForm, inputList, resolve, reject, stateRetriever);
                            window.addEventListener('message', this.receiveMessagePCIFunction, false);
                            pciFrame.contentWindow.postMessage('submit_pci_form', PCI_URL);
                          } else {
                            reject(Error('not valid form'));
                          }
                          break;
                        case 'Redsys':
                          this.onSubmit(validForm, inputList, resolve, reject);
                          break;
                        case 'xPay':
                          this.onSubmit(validForm, inputList, resolve, reject);
                          break;
                        case 'Paycomet':
                          this.onSubmit(validForm, inputList, resolve, reject);
                          break;
                        case 'Stripe':
                          this.onSubmit(validForm, inputList, resolve, reject);
                          break;
                        case 'Cardnet':
                          this.onSubmit(validForm, inputList, resolve, reject);
                          break;
                        default:
                          if(this.tpvEnabled) {
                            reject(Error('not valid form'));
                          }
                          break;
                      }
                      if(!this.tpvEnabled) {
                        const pciFrame = this.pciFrame;
                        this.receiveMessagePCIFunction = this.receiveMessagePCI(validForm, inputList, resolve, reject, stateRetriever);
                        window.addEventListener('message', this.receiveMessagePCIFunction, false);
                        pciFrame.contentWindow.postMessage('submit_pci_form', PCI_URL);
                      }
                    } else {
                      reject(Error('not valid form'));
                    }
                    break;
                  case 'paypal':
                    if (this.payPalEnabled && validForm) {
                      confirmBookingOnlyStore();
                      resolve({ payload: Map({ status: 'confirmed' }) });
                    } else {
                      reject(Error('not valid form'));
                    }
                    break;
                  case 'amazon_pay':
                    if (this.amazonPayEnabled && validForm) {
                      this.Amazon.initConfirmationFlow(
                        hotel.get('id'),
                        reservation,
                        hotelCurrencyCode,
                        amazonPayMerchantID,
                        confirmBookingOnlyStore,
                        resolve,
                        reject
                      );
                    } else {
                      reject(Error('not valid form'));
                    }
                    break;
                  case 'htlng':
                  case 'ccng':
                    this.onSubmit(validForm, inputList, resolve, reject);
                    break;
                  case 'htl':
                  case 'ccg':
                  default:
                    if(this.tpvEnabled === 'Stripe' ) {

                      this.STRIPE.initialize(
                        this.props.config.hotel,
                        this.props.config.reservation,
                        this.selectedCountry.get('alpha2'),
                        this.props.config.langCode.toLowerCase(),
                        this.formID,
                        this.props.config.currentCurrencyCode,
                        this.props.config.showErrorNotification,
                        this.state.payFormSelected
                      );

                      this.validateCardHolder(validForm,inputList);
                      if (!this.state.cardHolderError.error) {
                        this.paymentCallback().then((result) => {
                          if (result) {
                            //this.onSubmit(validForm, inputList, resolve, reject, true);
                          } else {
                            reject(Error('not valid form'));
                          }
                        });
                      } else {
                        reject(Error('not valid form'));
                      }
                    }
                    else {
                      if(validForm) {
                        const pciFrame = this.pciFrame;
                        //if (!this.paymentToken) {
                        this.receiveMessagePCIFunction = this.receiveMessagePCI(validForm, inputList, resolve, reject, stateRetriever);
                        window.addEventListener('message', this.receiveMessagePCIFunction, false);
                        pciFrame.contentWindow.postMessage('submit_pci_form', PCI_URL);
                        //} else {
                        //this.onSubmit(validForm, inputList, resolve, reject);
                        //}
                      } else {
                        reject(Error('not valid form'));
                      }
                    }
                    break;
                }
              }
            })

              .then(response => {
                logger.addLine('then payforms', '');
                let reservationResponse = response;
                // Paypal incluye el response real dentro de payload
                if(typeof reservationResponse.payload !== 'undefined') {
                  reservationResponse = reservationResponse.payload;
                }
                if (reservationResponse && reservationResponse.get('status', false) === 'confirmed') {
                  if ((this.state.payFormSelected !== 'op' && this.state.payFormSelected !== 'bizum') || reservationPaid || !this.tpvEnabled) {
                    logger.addLine('then submit diff op', reservationResponse);
                    if (!!this.tpvEnabled && (this.state.payFormSelected === 'op' || this.state.payFormSelected === 'bizum')) {
                      setReservationPayed(reservation, showTaxes);
                    }
                    this.props.config.showConfirmation(reservation, hotel);
                  } else if (this.tpvEnabled === 'EPG') {
                    logger.addLine('then submit EPG', reservationResponse);
                    if (validForm && this.EPG.prepayToken !== false) {
                      // en EPG es fa el pagament després de confirmar la reserva.
                      return this.EPG.chargePayment(
                        inputList,
                        hotel,
                        reservation,
                        hotelCurrencyCode,
                        showTaxes,
                        this.selectedCountry.get('alpha2'),
                        this.props.config.langCode.toLowerCase(),
                        this.formID,
                        setReservationPayed,
                        showConfirmation,
                        showErrorNotification,
                        this.setStateEPGPrepaymentToken,
                        this.checkTpvContainer,
                        manageLoading
                      );
                    }
                  } else if (this.tpvEnabled === 'SIBS') {
                    if (validForm) {
                      // Approved without 3DS requirement
                      var base_url = (process.env.NODE_ENV === 'production' ? 'https://synergy.booking-channel.com' : 'https://syn2pre.booking-channel.com');
                      var url = base_url + '/api/hotels/' + hotel.get('id') + '/cms/redirect_3d_secure/' + reservationResponse.get('hotel_code') + '-' + reservationResponse.get('tracking_id');
                      window.location.replace(url);
                    }
                  } else if (this.tpvEnabled === 'Redsys') {
                    if (validForm) {
                      this.REDSYS.validatePayment();
                    }
                  } else if (this.tpvEnabled === 'xPay') {
                    if (validForm) {
                      this.XPAY.validatePayment();
                    }
                  } else if (this.tpvEnabled === 'Cardnet') {
                    if (validForm) {
                      this.CARDNET.validatePayment();
                    }
                  } else if (this.tpvEnabled === 'Paycomet') {
                    if (validForm) {
                      return this.PAYCOMET.initialize(
                        hotel,
                        reservation,
                        this.selectedCountry.get('alpha2'),
                        this.props.config.langCode.toLowerCase(),
                        this.formID,
                        this.props.config.currentCurrencyCode,
                        showErrorNotification
                      ).then(() => {
                        this.PAYCOMET.validatePayment();
                      });

                    }
                  }
                  else if (this.tpvEnabled === 'Stripe') {
                    if (validForm) {
                      return this.STRIPE.initialize(
                        hotel,
                        reservation,
                        this.selectedCountry.get('alpha2'),
                        this.props.config.langCode.toLowerCase(),
                        this.formID,
                        this.props.config.currentCurrencyCode,
                        showErrorNotification,
                        this.state.payFormSelected
                      ).then(() => {
                        this.STRIPE.validatePayment();
                      });

                    }
                  }
                }
              })
              .catch(error => {
                logger.addLine('Error on show confirmation', error).sendMail();
                if (this.tpvEnabled === 'EPG' && this.EPG.onSubmitPromiseReject) {
                  return this.EPG.onSubmitPromiseReject(error);
                } else {
                  return error;
                }
              });
          }
        })
        .catch(error => {
          return error;
        });
    });
  };

  receiveMessagePCI = (validForm, inputList, resolve, reject, stateRetriever, toggleModal) => e => {
    const { manageLoading } = stateRetriever();
    const { changePayForm, setReservationToken, reservation } = this.props.config;
    const logger = loggerGetter();
    const message = e.data;
    logger.addLine('info receiveMessagePCI', message);
    if (e.origin === PCI_URL && message.indexOf('submit_booking_form') !== -1) {
      logger.addLine('info receiveMessagePCI submit_booking_form');
      window.removeEventListener('message', this.receiveMessagePCIFunction, false);
      [, this.paymentToken] = message.split(':');
      if (this.paymentToken.length > 0) {
        this.onSubmit(validForm, inputList, resolve, reject);
        if (this.state.showCardValidationError) {
          this.setState(state =>
            mergeDeepRight(state, {
              showCardValidationError: false
            })
          );
        }
      }
    } else if (e.origin === PCI_URL && message.indexOf('error_booking_form') !== -1) {
      logger.process('stop').clearLog();
      window.removeEventListener('message', this.receiveMessagePCIFunction, false);
      this.setState(state =>
        mergeDeepRight(state, {
          showCardValidationError: true
        })
      );
      // scroll to first unvalid
      if (validForm) {
        this.pciFrame.scrollIntoView();
        window.scrollBy(0, -65);
      }
      reject(Error(message));
    } else if (e.origin === PCI_URL && message.indexOf('card_type_selected') !== -1) {
      logger.addLine('info receiveMessagePCI card_type_selected');
      const aux = message.split(':');
      window.payForm = this.state.payFormSelected;
      window.cardSelected = aux[1];
    } else if (e.origin === PCI_URL && message.indexOf('redirect_3ds') !== -1) {
      logger.addLine('info receiveMessagePCI redirect_3ds new_cof');
      const [, paymentToken, url3DSecureRedirection] = message.split('#');
      this.paymentToken = paymentToken;
      changePayForm(validForm, inputList, false, false, this.paymentToken).then(() => {
        window.location.replace(url3DSecureRedirection);
      });
    } else if (e.origin === PCI_URL && message.indexOf('FORM') !== -1) {
      const [, paymentToken, form] = message.split('#');
      this.paymentToken = paymentToken;
      let decodedForm = atob(form);
      let queryObj = {};
      let redsysApi;
      if (decodedForm.indexOf('new') !== -1) {
        const [, creq, url] = decodedForm.split('#');
        queryObj.creq = creq;
        redsysApi = apiGetter(url, 'form');
      } else {
        const [, PaReq, TermUrl, MD, url] = decodedForm.split('#');
        queryObj.PaReq = PaReq;
        queryObj.TermUrl = TermUrl;
        queryObj.MD = MD;
        redsysApi = apiGetter(url, 'form');
      }
      setReservationToken(reservation, this.paymentToken);
      redsysApi.post(queryObj);
    } else if (e.origin === PCI_URL && message.indexOf('XPAY') !== -1) {
      const [, paymentToken, form] = message.split('#');
      this.paymentToken = paymentToken;
      let decodedForm = atob(form);
      let xpayApi;
      const [url, params] = decodedForm.split('#');
      const jsonParams = JSON.parse(params);
      xpayApi = apiGetter(url,'form');
      setReservationToken(reservation, this.paymentToken);
      xpayApi.post(jsonParams);
    } else if (e.origin === PCI_URL && message.indexOf('SIBS') !== -1) {
      // Sibs 3DS iframe
      const [, paymentToken, form] = message.split('#');
      this.paymentToken = paymentToken;
      let decodedForm = atob(form);
      const [, creq, url] = decodedForm.split('#');

      manageLoading(false);
      this.showSibsIframe(url, creq, reject);
      setReservationToken(reservation, this.paymentToken);
    } else if (e.origin.indexOf("sibs.pt") !== -1 && message.type === "close" && message.source === "sibs") {
        // Sibs 3DS result
        reject();
        const {toggleModal } = this.props.config;
        toggleModal(false, "sibsIframe");
                
        const { manageLoading } = this.stateRetriever();
        this.SIBS.confirm(reservation, manageLoading, this.setCardValidationError);
    } /*else if (e.origin === PCI_URL && message.indexOf('hide_card_error') !== -1) {
      this.setState(state =>
        mergeDeepRight(state, {
          showCardValidationError: false
        })
      );
    }*/

    return true;
  };

  setCardValidationError = (value) => {
    this.setState(state =>
      mergeDeepRight(state, {
        showCardValidationError: value
      })
    );
  };

  showSibsIframe = (url, creq, reject) => {
    const {toggleModal } = this.props.config;

    toggleModal(true, "sibsIframe", <SibsFrame src={url} creq={creq} closeModal={()=> {
      reject();
      toggleModal(false, "sibsIframe");
    }} />);
  };

  onSubmit = (validForm, inputList, resolve, reject, fromTPV = false) => {
    const { triggerEvent } = this.props.config;

    if (validForm) {
      const { hotel, reservation, confirmBookingEPG, confirmBooking, confirmBookingRedsys, confirmBookingPaycomet, confirmBookingStripe, confirmBookingXpay, showTaxes } = this.props.config;
      let promise, errorType;
      let reservationPayformCode = reservation.getIn(['payment','payform_code'], false);
      let amountPayed = false;
      if(reservationPayformCode === 'op') {
        amountPayed = reservation.get(showTaxes ? 'total_price_tax' : 'total_price')
      }

      if (fromTPV && this.tpvEnabled === 'EPG') {
        errorType = 'payment';
        promise = confirmBookingEPG(
          inputList,
          false,
          hotel.get('id'),
          reservation.get('tracking_id'),
          hotel.getIn(['tpv', 'id']),
          hotel.getIn(['tpv', 'name']),
          this.EPG.paymentToken,
          this.EPG.nRetry
        );
      } else if (fromTPV && this.tpvEnabled === 'Redsys') {
        errorType = 'payment';
        promise = confirmBookingRedsys(
          inputList,
          false,
          hotel.get('id'),
          reservation.get('tracking_id'),
          hotel.getIn(['tpv', 'id']),
          hotel.getIn(['tpv', 'name'])
        );
      } else if (fromTPV && this.tpvEnabled === 'xPay') {
        errorType = 'payment';
        promise = confirmBookingXpay(
          inputList,
          false,
          hotel.get('id'),
          reservation.get('tracking_id'),
          hotel.getIn(['tpv', 'id']),
          hotel.getIn(['tpv', 'name'])
        );
      } else if (fromTPV && this.tpvEnabled === 'Paycomet') {
        errorType = 'payment';
        promise = confirmBookingPaycomet(
          inputList,
          false,
          hotel.get('id'),
          reservation.get('tracking_id'),
          hotel.getIn(['tpv', 'id']),
          hotel.getIn(['tpv', 'name'])
        );
      } else if (fromTPV && this.tpvEnabled === 'Stripe') {
        errorType = 'payment';

        promise = confirmBookingStripe(
          inputList,
          false,
          hotel.get('id'),
          reservation.get('tracking_id'),
          hotel.getIn(['tpv', 'id']),
          hotel.getIn(['tpv', 'name'])
        );
      } else if(!this.tpvEnabled) {
        errorType = 'pci';
        promise = confirmBooking(inputList, this.paymentToken, amountPayed);
      } else {
        errorType = 'unknown';
        promise = confirmBooking(inputList, this.paymentToken);
      }

      return promise
        .tapCatch(() => triggerEvent('confirm_error', errorType))
        .then(resolve)
        .catch(reject);
    } else {
      triggerEvent('confirm_error', 'required_fields');
      return reject(Error('Invalid form'));
    }
  };

  onBlur = (validForm, inputList, model, stateRetriever) => {

    if (model === 'nationality') {
      this.setState(()=> {
        return { showIdentifierDocument : DOCUMENT_TYPES[inputList['nationality'].value?.get("alpha2")] };
      });
    }

    if (model === 'already_member') return;

    const { reservation, hotel, showErrorNotification,setPayformOP, blacklistedEmails } = this.props.config;
    if (model.indexOf('room_preference') !== -1) {
      this.changeRoomPreferences(validForm, inputList);
    } else if (model === 'payForm') {
      this.onChangePayForm(validForm, inputList, model, stateRetriever);
    } else {

      if (model === 'country') {
        this.selectedCountry = inputList['country'].value;
        if (this.tpvEnabled === 'EPG') {
          this.EPG.initialize(
            hotel,
            reservation,
            this.selectedCountry.get('alpha2'),
            this.props.config.langCode.toLowerCase(),
            this.formID,
            showErrorNotification,
            this.setStateEPGPrepaymentToken,
            this.checkTpvContainer
          );
        }
      }

      if(model === 'travelclub_card') {
        this.validateTravelclubCard(validForm, inputList, reservation);
      }
      if(model === 'card_holder' ) {
        this.validateCardHolder(validForm, inputList, reservation);
      }

      if(this.tpvEnabled && model === 'email' && blacklistedEmails && blacklistedEmails.includes(inputList['email'].value)) {
        this.changePayformOP();
        setPayformOP(inputList);
        this.onChangePayForm(validForm, inputList, model, stateRetriever, true);
      }

      this.props.config.saveCustomerData(validForm, inputList, model, this.state.showBookerGuestForm).then(() => {
        this.validateRepeatBooking(validForm, inputList, reservation);
      });
    }
    this.validForm = validForm;
  };

  onChangePayForm = (validForm, inputList, model, stateRetriever, forceOP = false) => {
    this.stateRetriever = stateRetriever;
    const { reservation, hotel, showErrorNotification, changePayForm, cancelBooking, confirmBooking, showConfirmation, setStripeToken, showTaxes } = this.props.config;
    const { disableSubmit, manageLoading } = stateRetriever();
    let reservationPayformCode = reservation.getIn(['payment','payform_code'], false);
    let amountPayed = false;
    if(reservationPayformCode === 'op') {
      amountPayed = reservation.get(showTaxes ? 'total_price_tax' : 'total_price')
    }

    if (this.paymentToken && this.returnFromSuccessCof) {
      /*const { manageLoading } = stateRetriever();*/
      const promise = confirmBooking(inputList, this.paymentToken, amountPayed);
      manageLoading(true);
      return promise
        .then(() => {
          //manageLoading(false);
          return showConfirmation(reservation, hotel);
        })
        .catch((e) => {
          manageLoading(false);
          return showErrorNotification('_%error al procesar su reserva, por favor, vuelva a intentarlo%_');
        });
    }


    if (this.tpvEnabled === 'EPG') {
      // l'assignem aquí per tenir-lo disponible en posteriors events de reset
      this.EPG.successEvent = this.EPG.onValidate(
        stateRetriever,
        this.validatePaymentForms,
        this.setStateEPGPrepaymentToken,
        reservation.get('tracking_id')
      );
    }
    const onlinePayment = Map({ code: 'op', name: 'pago online' })
    if(forceOP) {
      inputList["payForm"].onChange(onlinePayment, true);
    }

    let payFormCode = inputList['payForm'] && inputList['payForm'].value.get('code');

    if (payFormCode) {
      disableSubmit(1, 0);

      return new Promise((resolve, reject) => {
        if (!!this.tpvEnabled && reservation.getIn(['payment', 'payform_code']) === 'op' && payFormCode === 'htl' && reservation.get('status') === 'confirmed') {
          cancelBooking(inputList).then(() => resolve());
        } else {
          resolve();
        }
      }).then(() => {
        changePayForm(validForm, inputList, this.tpvEnabled, false, this.paymentToken);
        if (this.tpvEnabled === 'EPG' && this.EPG.loadingTpvAuth === false) {
          this.EPG.initialize(
            hotel,
            reservation,
            this.selectedCountry.get('alpha2'),
            this.props.config.langCode.toLowerCase(),
            this.formID,
            showErrorNotification,
            this.setStateEPGPrepaymentToken,
            this.checkTpvContainer
          );
        }
        if (this.tpvEnabled === 'Redsys') {
          this.REDSYS.initialize(
            hotel,
            reservation,
            this.selectedCountry.get('alpha2'),
            this.props.config.langCode.toLowerCase(),
            this.formID,
            showErrorNotification,
            payFormCode
          );
        }
        if (this.tpvEnabled === 'xPay') {
          this.XPAY.initialize(
            hotel,
            reservation,
            this.selectedCountry.get('alpha2'),
            this.props.config.langCode.toLowerCase(),
            this.formID,
            this.props.config.currentCurrencyCode,
            showErrorNotification
          );
        }
        if (this.tpvEnabled === 'Cardnet') {
          if(payFormCode === 'op') {
            this.CARDNET.initialize(
              hotel,
              reservation,
              this.props.config.currentCurrencyCode,
              showErrorNotification
            );
          }
        }
        if (this.tpvEnabled === 'Stripe') {
          if(payFormCode === 'op') {
            this.STRIPE.initialize(
              hotel,
              reservation,
              this.selectedCountry.get('alpha2'),
              this.props.config.langCode.toLowerCase(),
              this.formID,
              this.props.config.currentCurrencyCode,
              showErrorNotification,
              payFormCode
            );
          } else if(payFormCode === 'htl') {
            const reservation = this.props.config.reservation;
            const hotel = this.props.config.hotel;
            const requiredPrepayment = this.props.config.requiredPrepayment;
            const fullFreeReservation = this.props.config.fullFreeReservation;
            const notRefundable = this.props.config.notRefundable;

            let requiredPrepaymentCalc = 0;
            if (requiredPrepayment > 0 && !fullFreeReservation && !notRefundable ) {
              requiredPrepaymentCalc = requiredPrepayment;

            } else {
              requiredPrepaymentCalc = 0;
            }
            setStripeToken(
              this.props.config.currentCurrencyCode,
              this.props.config.langCode.toLowerCase(),
              requiredPrepaymentCalc, hotel.get('code'), reservation.get('tracking_id'), document.URL);
          }
        }
        this.setState(state =>
          mergeDeepRight(state, {
            payFormSelected: payFormCode
          })
        );
        disableSubmit(0, 0);
      }).catch(error => {
        disableSubmit(0, 0);
      });
    }
  };

  setAmazonReferenceId = (validForm, inputList) => (amazonOrderRefId, nRetry) => {
    const { changePayForm } = this.props.config;
    changePayForm(validForm, inputList, 'amazon_pay', { amazonOrderRefId: amazonOrderRefId, TPVnRetry: nRetry });
    return amazonOrderRefId;
  };

  setPayPalOrderId = (validForm, inputList) => (OrderId, nRetry) => {
    const { changePayForm } = this.props.config;
    changePayForm(validForm, inputList, 'paypal', { PayPalOrderId: OrderId, TPVnRetry: nRetry });
    return OrderId;
  };

  setInnerRef = (ref) => this.setState({ heightRef: ref });

  changePayformOP = () => {
    this.setState({selecectedPayform: 'op'});

  }

  toggleRoomPreferences = idx => e => {
    e.preventDefault();
    this.setState(state =>
      mergeDeepRight(state, {
        showRoomPreferences: {
          [idx]: !state.showRoomPreferences[idx]
        }
      })
    );
  };

  toggleEditUserFields = e => {
    e.preventDefault();
      this.setState(state =>
        mergeDeepRight(state, {
          showEditUserFields: !state.showEditUserFields,
          showUserInfo : !state.showUserInfo,
          userChanged : true
        })
      );
  };

  updateAfterTransition = () => {
    if (this.state.editCommentary) {
      this.setState({ heightContainer: 'auto' });
    }
  };

  toggleAdditionalCommentary = e => {
    e.preventDefault();
    this.setState(state => ({
      editCommentary: !state.editCommentary,
      heightContainer: this.state.heightRef.scrollHeight
    }));
  };

  togglePromotionalCode = e => {
    e.preventDefault();
    this.setState(state => ({
      showPromotionalBox: !state.showPromotionalBox
    }));
  };

  toggleLoyaltyPaymentPoints = e => {
    e.preventDefault();
    this.setState(state => ({
      showLoyaltyPaymentPoints: !state.showLoyaltyPaymentPoints
    }));
  };

  toggleTravelClub = e => {
    e.preventDefault();
    this.setState(state => ({
      showTravelClub: !state.showTravelClub
    }));
  };

  changeRoomPreferences = (validForm, inputList) => {
    const blockIdx = keys(inputList)[0].split('-')[1];
    return this.props.config.changeRoomPreferences(blockIdx, inputList);
  };

  setPciFrameRef = ref => {
    this.pciFrame = ref;
  };

  AcceptAlertBookingRepeated = isAccepted => e => {
    e.preventDefault();
    this.setState(
      state => {
        return {
          repeatedBooking: {
            ...state.repeatedBooking,
            clientAccepted: isAccepted
          }
        };
      },
      () => {
        if (isAccepted) {
          this.acceptedReapetedBookingPromise.resolve();
        } else {
          this.acceptedReapetedBookingPromise.reject(Error('Duplicate reservation'));
        }
      }
    );
  };

  paymentCallbackRegister = callback => {
    this.paymentCallback = callback;
  };

  toggleBookerGuest = e => {
    this.setState(state => ({
      showBookerGuestForm: !state.showBookerGuestForm
    }));
  };

  render() {
    const { config, theme, content } = this.props;
    const {

        hotel,
        reservation,
        reservationTotals,
        langCode,
        checkin,
        stayLength,
        hotelCurrencyCode,
        currentCurrencyCode,
        countries,
        hotelPreferences,
        blocks,
        sections,
        cfees15d,
        showTaxes,
        reservationPaid,
        fullFreeReservation,
        directPayment,
        amountToPay,
        managementGroupID,
        gift_voucher,
        showErrorNotification,
        langInfo,
        currencies,
        requiredPrepayment,
        requiredPrepaymentValue,
        requiredPrepaymentType,
        stripeToken,
        loyaltyUser,
        loyaltySelected,
        loyaltyType,
        ipCountry,
        giftCodeDiscount,
        blacklistedEmails
      } = config;
    const { classes } = theme.styles;

    const isStarTraveler = STAR_TRAVELER_CODE === loyaltyType;

    const showUserInfo = this.state.showUserInfo;
    const showEditUserFields = this.state.showEditUserFields;

    const resDocDefault = reservation.getIn(['customer', 'document_type']);
    const defaultDoc = this.state.showIdentifierDocument && (find((curr)=>{
      return curr.value === resDocDefault;
    }, this.state.showIdentifierDocument) || this.state.showIdentifierDocument[0]);


    // flexmyroom | secure cancellation
    const rateSecureCancellation = reservation && reservation?.get('rates')?.some(d => d?.get('secure_cancellation', false));
    const discountSecureCancellation = reservation && reservation?.get('discounts')?.some(d => d?.get('secure_cancellation', false));
    const serviceSecureCancellation = reservation && reservation?.get('services')?.some(d => d?.get('secure_cancellation', false));
    const pmsName = hotel && hotel.get('pms');
    const pms = ((rateSecureCancellation || discountSecureCancellation || serviceSecureCancellation) && pmsName === 'FlexMyRoom') ? 'FlexMyRoom' : false;
    let reservationEmail = reservation.getIn(['customer', 'email'], '')
    let blacklistedEmail = this.tpvEnabled && reservationEmail && blacklistedEmails && blacklistedEmails.includes( reservationEmail );

    const hotelId = hotel && hotel.get('id');
    const penalties = getPenalties(reservation, managementGroupID === PROPERTY_MANAGEMENT_GROUP, pms, langCode, managementGroupID);
    const notRefundable = penalties[0].nr || penalties[0].flexible || false;
    const hotelCode = hotel && hotel.get('code');
    const showCVC = hotel && hotel.getIn(['payment_info', 'show_cvc']) ? 1 : 0;
    const trackingId = reservation && reservation.get('tracking_id');
    const checkinPCI = checkin && moment(checkin).format('DDMMYYYY');
    const checkoutPCI =
      checkin &&
      moment(checkin)
        .add(stayLength, 'days')
        .format('DDMMYYYY');
    const totalPrice = reservationTotals ? reservationTotals.get('total_price') : 0;
    const endTotalPrice = totalPrice + giftCodeDiscount;
    const discountAmount = reservationTotals ? reservationTotals.get('discount_amount') : 0;
    const discountPercent = reservationTotals ? reservationTotals.get('discount_percent') : 0;
    const redsysRedirection = (this.tpvEnabled === 'Redsys' && this.tpvEnabledType === 'redireccion');
    const redsysBizum = (this.tpvEnabled === 'Redsys' && this.tpvBizumRedsys === '1');
    const paycometRedirection = this.tpvEnabled === 'Paycomet';
    const xpayRedirection = this.tpvEnabled === 'xPay' && reservation.getIn(['payment', 'payform_code'], false) === 'op';
    const cardnetRedirection = this.tpvEnabled === 'Cardnet' && reservation.getIn(['payment', 'payform_code'], false) === 'op';
    const stripeRedirection = this.tpvEnabled === 'Stripe' && reservation.getIn(['payment', 'payform_code'], false) === 'op';
    const isBizum = redsysBizum && reservation && reservation.getIn(['payment', 'payform_code'], false) === 'op' && reservation.getIn(['payment', 'bizum_charge'], false) === true;
    const otherOps = this.payPalEnabled || this.amazonPayEnabled || redsysBizum;
    const isStripeHtl = this.tpvEnabled === 'Stripe' && this.state.payFormSelected === 'htl';
    const opShow = (redsysRedirection || paycometRedirection || stripeRedirection || xpayRedirection || cardnetRedirection) && !otherOps && (notRefundable || blacklistedEmail);
    let showTpvForm = !reservationPaid && !opShow;
    let reservationPayformCode = reservation.getIn(['payment','payform_code'], false);
    const UserLoggedST = !!loyaltyUser && loyaltyType === STAR_TRAVELER_CODE;

    // Forces online payment (op) and hides pay-at-hotel option (htl) if PMS is flexmyroom and TPV is enabled
    if (pms && this.tpvEnabled) {
      showTpvForm = false;
      reservationPayformCode = 'op';
    }

    const cityTax = hotel && hotel.get('city_tax');
    const isMobile = this.props.theme.deviceType !== 'DESK';
    const hasPromotion = reservation && reservation.getIn(['promotion', 'code'], false);
    const hidePromotionCode = hotel && !hasPromotion && managementGroupID !== PROPERTY_MANAGEMENT_GROUP && isMobile && hotel.get('has_mobile_discount', false) === true;
    const legalText = this.props.content.getHasKeyAndContent('_%el uso de este formulario implica el tratamiento de tus datos%_');
    const dataControllerText = this.props.content.getHasKeyAndContent('_%data_controller_text%_');
    let stripeOptions = false;
    let stripePromise = false;

    if(isStripeHtl && stripeToken) {
      let tpv = hotel.getIn(['tpv', 'tpv_params'], false);
      let publicKey = tpv && tpv.find(p => p.get('code') === 'public_key', Map()).get('value', '');
      let stripeAccount = tpv && tpv.find(p => p.get('code') === 'account', Map()).get('value', '');
      let stripeCons = {
        stripeAccount : stripeAccount
      };
      stripePromise = loadStripe(publicKey, stripeCons);
      stripeOptions = {
        // passing the client secret obtained in step 3
        clientSecret: stripeToken,
        locale: langCode,
        // Fully customizable with appearance API.
        appearance : {
          theme: 'flat',
        }
      };
    }
    let showAlertRepeatedBooking =
      this.state.repeatedBooking.status === 'repeated' &&
      this.state.repeatedBooking.submited &&
      this.state.repeatedBooking.clientAccepted === null;

    const PSD2Active = hotel && hotel.getIn(['pci', 'psd2_active'], false) === true && !!hotel.getIn(['tpv', 'name'], false);

    let requiredPrepaymentText = '';
    let requiredPrepaymentCalc = 0;

    if (requiredPrepayment > 0 && !fullFreeReservation && !notRefundable && currencies) {
      requiredPrepaymentCalc = requiredPrepayment;
      requiredPrepaymentText = getPrepaymentText(
        requiredPrepayment,
        requiredPrepaymentValue,
        requiredPrepaymentType,
        currencies,
        currentCurrencyCode,
        hotelCurrencyCode,
        langInfo,
        content
      );
    } else if (this.tpvEnabled === 'SIBS') {
      requiredPrepaymentCalc = reservation.get('total_price_tax') - reservation.getIn(['payment', 'amount_promo_paid'], 0);
    } else if(UserLoggedST && reservationPayformCode === 'op') {
      requiredPrepaymentCalc = amountToPay;
    } else {
      requiredPrepaymentCalc = 0;
    }

    const country = (reservation && reservation.getIn(['customer', 'country'], false));
    const showStateSelector = country === 'AR';
    const states = fromJS(AR_STATES);

    const currentState = (reservation && reservation.getIn(['customer', 'state'], false));
    const hotelCountry = hotel && hotel.get('country_iso_code', '');
    //const showLoyaltyPaymentPoints = loyaltyUser?.getIn(['points', 'allow_redeem'], false) === true;
    const showLoyaltyPaymentPoints = false;
    const enableRegisterUserST = isStarTraveler && loyaltySelected && !loyaltyUser;
    const hotelUS = hotelCountry === 'US' && managementGroupID === PROPERTY_MANAGEMENT_GROUP;

    //ShowTravelClub
    const ipTravelClub = ['ES', 'PT', 'AD'].includes(ipCountry);


    return (
      <div className={classes.defaultStyle}>
        <LoyaltyUserPoints/>
        <SearchOptions innerStyle={['monoHotelSearchOptions']}/>
        {showAlertRepeatedBooking && (
          <div className={classes.alertContainer}>
            <div id="login-front"></div>
            <div className={classes.alertContent}>
              <RichText
                innerStyle={['alertForm', 'bold', classes.alertTitle]}
                translate={true}
                ucFirst={true}
                text={'_%¡Atención!%_'}
              />
              <RichText
                innerStyle={['alertForm']}
                translate={true}
                ucFirst={true}
                text={'_%ya has realizado una reserva similar.¿Seguro que deseas confirmar tu reserva?%_'}
              />
              <div className={classes.alertButtonContainer}>
                <Button
                  onClick={this.AcceptAlertBookingRepeated(true)}
                  richText={{
                    translate: true,
                    text: '_%si%_',
                    ucFirst: true
                  }}
                  innerStyle={['alertButton']}
                />
                <Button
                  onClick={this.AcceptAlertBookingRepeated(false)}
                  richText={{
                    translate: true,
                    text: '_%no%_',
                    ucFirst: true
                  }}
                  innerStyle={['alertButton']}
                />
              </div>
            </div>
          </div>
        )}


        <div className={classes.page}>
          <div className={classes.section}>
          {<LoyaltyLogin customerForm={true} />}
            <div className={classes.sectionForm}>
              {showEditUserFields && <RichText innerStyle={[classes.title]} ucFirst={true} text={"_%tus Datos%_"} translate={true} />}
              <Form
                formVersion={2}
                onValidateForm={(validForm, inputList)=>{
                  if (!validForm && !showEditUserFields) {
                    const hiddenFieldsError = this.validateFields(pick(['name', 'surname', 'email', 'repeatEmail', 'phone', 'country'], inputList));
                    !hiddenFieldsError && this.setState({ showUserInfo: false, showEditUserFields:true });
                  }
                }}
                filterInputModel={(inputList) => {
                  let newInputs = inputList;
                  const showIdentifierDocument = DOCUMENT_TYPES[inputList['nationality']?.value?.get('alpha2')];

                  if(enableRegisterUserST && showIdentifierDocument) {
                    newInputs = omit(['booker_check','booker_repeat_email'], newInputs);
                  } else if(enableRegisterUserST) {
                    newInputs = omit(['document_type', 'tax_number','booker_check','booker_repeat_email'], newInputs);
                  } else {
                    newInputs = omit(['nationality', 'document_type', 'tax_number','booker_check','booker_repeat_email'], newInputs);
                  }

                  return newInputs;
                }}
                disableLoading={true}
                loadingTemplate={LoadingConfirmation}
                id={this.formID}
                onChange={this.onChange}
                onBlur={this.onBlur}
                onSubmit={this.validateLoyaltyUser}
                onMount={this.onChangePayForm}
                innerStyle={classes.customerForm}>
                <LoyaltyUserInfo
                  visible={showUserInfo}
                  toggle={this.toggleEditUserFields}
                  phone={this.selectedPhone}
                  flag={this.props.content?.getCountryFlags(this.selectedCountry.get('alpha2', ''))}
                  country={this.selectedCountry.get('phone_prefix', '')}
                  classes={classes}
                  />
                <div className={[showEditUserFields ? '' : classes.userTravelContainer]}>
                  <label className={[classes.inputBox, showEditUserFields ? '' : classes.hide].join(' ')} ref={'name'}>
                    <InputField
                      model={'name'}
                      defaultValue={reservation.getIn(['customer', 'name'], '') || (loyaltyUser?.getIn(['name'], ''))}
                      innerStyle={['inputText', classes.inputText]}
                      validationsFields={{ field: 'nombre' }}
                      autoFocus={true}
                      validations={[
                        'required',
                        { type: 'maxLength', maxLength: 100 },
                        { type: 'minLength', minLength: 2 }
                      ]}
                    />
                    <InputNotify model={'name'} />
                    <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%nombre%_'} translate={true} />
                  </label>
                  <label className={[classes.inputBox, showEditUserFields ? '' : classes.hide].join(' ')}
                         ref={'surname'}>
                    <InputField
                      model={'surname'}
                      defaultValue={reservation.getIn(['customer', 'surname'], '') || (loyaltyUser?.getIn(['surname'], ''))}
                      validationsFields={{ field: 'apellidos' }}
                      validations={[
                        'required',
                        { type: 'minLength', minLength: 2 },
                        { type: 'maxLength', maxLength: 100 }
                      ]}
                      innerStyle={['inputText', classes.inputText]}
                    />
                    <InputNotify model={'surname'} />
                    <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%apellidos%_'} translate={true} />
                  </label>
                  <label className={[classes.inputBox, showEditUserFields ? '' : classes.hide].join(' ')} ref={'email'}>
                    <InputField
                      model={'email'}
                      defaultValue={reservation.getIn(['customer', 'email'], '') || (loyaltyUser?.getIn(['email'], ''))}
                      validationsFields={{ field: 'email' }}
                      validations={[
                        'required',
                        'email',
                        'loyaltyEmail',
                        {
                          type: 'compareField',
                          invalidText: '',
                          alterModel: 'repeatEmail',
                          alterField: 'repetir email'
                        },
                      ]}
                      innerStyle={['inputText', classes.inputText]}
                      type={'email'}
                    />
                    <InputNotify model={'email'} />
                    <div className={classes.labelText}>
                      <div className={managementGroupID === PROPERTY_MANAGEMENT_GROUP && classes.emailWithInfo}>
                          <RichText innerStyle={['capitalize']} text={'_%email%_'} translate={true}/>
                        {managementGroupID === PROPERTY_MANAGEMENT_GROUP &&
                        <TooltipWrapper
                          popover={<span className={[classes.ratePopover]}>
                            <RichText
                              translate={true}
                              text={'_%en caso de la no finalización de la reserva te enviaremos un email, a esta dirección de correo, por si has tenido algún problema en el proceso.%_'}
                              ucFirst={true}
                            /></span>}
                          popoverStyle={classes.rateTooltip}
                          bottomLimit={100}
                          typeTooltip={'infoEmailTooltip'}
                          pointerStyle={[classes.tooltipPointerStyle, classes.tooltipEmail].join(' ')}
                          posX={'middle'}
                          posY={'top'}>
                          <div className={classes.infoFloatIcon}>
                            <Image svg={'infoIcon'}/>
                          </div>
                        </TooltipWrapper>}
                      </div>
                    </div>
                  </label>
                  <label className={[classes.inputBox, showEditUserFields ? '' : classes.hide].join(' ')} ref={'repeatEmail'}>
                    <InputField
                      model={'repeatEmail'}
                      defaultValue={reservation.getIn(['customer', 'email'], '') || (loyaltyUser?.getIn(['email'], ''))}
                      validationsFields={{ field: 'repetir email' }}
                      validations={[
                        'required',
                        'email',
                        {
                          type: 'compareField',
                          alterModel: 'email',
                          alterField: 'email'
                        },
                      ]}
                      innerStyle={['inputText', classes.inputText]}
                      type={'email'}
                    />
                    <InputNotify model={'repeatEmail'} />
                    <RichText
                      innerStyle={[classes.labelText]}
                      ucFirst={true}
                      text={'_%repetir email%_'}
                      translate={true}
                    />
                  </label>
                  {enableRegisterUserST && <>
                    <label className={classes.inputBox}>
                      <RichText
                        innerStyle={[classes.nationalityLabel, classes.labelText]}
                        ucFirst={true}
                        text={'_%nacionalidad%_'}
                        translate={true}
                      />
                      <div className={[classes.selectBox, classes.nationalityContainer].join(' ')}>
                        <SelectField
                          verifyInListSelected={true}
                          getOptionLabel={option => option.get('name')}
                          getOptionValue={option => option.get('alpha2')}
                          model={'nationality'}
                          validations={['required', 'tax_number']}
                          innerStyle={[classes.nationalitySelector]}
                          defaultValue={this.defaultNationality}
                          options={countries}
                          styles={{
                            control: base => ({
                              ...base,
                              height: '100%',
                              border: 'none',
                              position: 'relative'
                            }),
                            SingleValue: base => ({
                              ...base,
                              height: '100%',
                              verticalAlign: 'middle'
                            }),
                            noOptionsMessage: base => ({
                              ...base,
                              textAlign: 'left',
                            }),
                            menu: base => {
                              return {
                                ...base,
                                zIndex: '10',
                                width: '100%'
                              };
                            },
                            menuList: base => {
                              return {
                                ...base,
                                width: 'auto',
                                overflowX: 'hidden',
                                maxHeight: '140px'
                              };
                            },
                            input: base => {
                              return {
                                ...base,
                                position: 'absolute'
                              };
                            },
                            valueContainer: base => {
                              return {
                                ...base,
                                height: '30px'
                              };
                            },
                            indicatorSeparator: base => {
                              return {
                                ...base,
                                display: 'none'
                              };
                            },
                            indicatorsContainer: base => {
                              return {
                                pointer: 'cursor',
                                ...base,
                                position: 'absolute',
                                top: 0,
                                right: langCode !== 'AR' ? -4 : 'auto',
                                left: langCode !== 'AR' ? 'auto' : -4,
                                bottom: 0
                              };
                            },
                            dropdownIndicator: base => ({
                              ...base,
                              pointer: 'cursor',
                              color: theme.themeValues.mainColor,
                              '&:hover': {
                                color: theme.themeValues.mainColor
                              }
                            })
                          }}
                        />
                      </div>
                    </label>
                  </>}
                  <label className={[classes.inputBox, showEditUserFields ? '' : classes.hide].join(' ')}>
                    <div className={classes.phoneContainer}>
                      <SelectCountry defaultCountry={this.defaultCountry} countries={countries}
                                     arrowPosition={langCode} />
                      <label className={classes.inputBox} ref={'phone'}>
                        <InputField
                          model={'phone'}
                          defaultValue={reservation.getIn(['customer', 'phone'], '') || this.selectedPhone}
                          validationsFields={{ field: 'teléfono' }}
                          validations={['required', 'phone']}
                          innerStyle={['inputText', classes.inputText]}
                          type={'tel'}
                        />
                        <InputNotify model={'phone'} />
                        <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%teléfono%_'}
                                  translate={true} />
                      </label>
                    </div>
                  </label>
                  {enableRegisterUserST && this.state.showIdentifierDocument && <>
                    <label className={classes.inputBox}>
                      <div className={classes.docTypeContainer}>
                        <div className={[classes.selectBox, classes.selectDocType].join(' ')}>
                          <SelectField
                            getOptionLabel={option => option.value}
                            getOptionValue={option => {
                              return option.value;
                            }}
                            model={'document_type'}
                            verifyInListSelected={true}
                            validations={['required', 'tax_number']}
                            innerStyle={[classes.documentSelect]}
                            defaultValue={defaultDoc}
                            options={this.state.showIdentifierDocument}
                            styles={{
                              control: base => ({
                                ...base,
                                height: '100%',
                                border: 'none',
                                position: 'relative'
                              }),
                              SingleValue: base => ({
                                ...base,
                                height: '100%',
                                verticalAlign: 'middle'
                              }),
                              menu: base => {
                                return {
                                  ...base,
                                  zIndex: '10',
                                  width: '100%'
                                };
                              },
                              menuList: base => {
                                return {
                                  ...base,
                                  width: 'auto',
                                  overflowX: 'hidden',
                                  maxHeight: '140px'
                                };
                              },
                              input: base => {
                                return {
                                  ...base,
                                  position: 'absolute'
                                };
                              },
                              valueContainer: base => {
                                return {
                                  ...base,
                                  height: '30px'
                                };
                              },
                              indicatorSeparator: base => {
                                return {
                                  ...base,
                                  display: 'none'
                                };
                              },
                              indicatorsContainer: base => {
                                return {
                                  ...base,
                                  position: 'absolute',
                                  top: 0,
                                  right: langCode !== 'AR' ? -4 : 'auto',
                                  left: langCode !== 'AR' ? 'auto' : -4,
                                  bottom: 0
                                };
                              },
                              dropdownIndicator: base => ({
                                ...base,
                                cursor: 'pointer',
                                color: theme.themeValues.mainColor,
                                '&:hover': {
                                  color: theme.themeValues.mainColor
                                }
                              })
                            }}
                          />
                        </div>
                        {this.state.showIdentifierDocument && <label className={classes.inputBox} ref={'tax_number'}>
                          <InputField
                            model={'tax_number'}
                            defaultValue={reservation.getIn(['customer', 'tax_number'], '') || (loyaltyUser?.getIn(['tax_number'], ''))}
                            innerStyle={['inputText', classes.inputText]}
                            validationsFields={{ field: 'documento identidad' }}
                            validations={[
                              'required',
                              'tax_number'
                            ]}
                          />
                          <InputNotify model={'tax_number'} />
                          <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%documento identidad%_'}
                                    translate={true} />
                        </label>}
                      </div>
                    </label>
                  </>}
                  {/* addressLine1 */}
                  {(hotelUS || this.tpvEnabled === 'Cardnet' ) &&
                    <label
                      className={[classes.inputBox, managementGroupID, showEditUserFields ? '' : classes.rightMargin].join(' ')}
                      ref={'addressLine1'}>
                      <InputField
                        model={'addressLine1'}
                        innerStyle={['inputText', classes.inputText]}
                        type={'text'}
                        validationsFields={{ field: 'dirección' }}
                        validations={[
                          'required',
                          { type: 'minLength', minLength: 2 },
                          { type: 'maxLength', maxLength: 100 }
                        ]}
                      />
                      <InputNotify model={'addressLine1'} />
                      <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%dirección%_'}
                                translate={true} />
                    </label>}
                  {(hotelUS || this.tpvEnabled === 'Cardnet' )  && <>
                    <label className={[classes.inputBox, showEditUserFields ? '' : classes.rightMarginNo].join(' ')}
                           ref={'customerCountry'}>
                      <RichText
                        innerStyle={[classes.countryLabel, classes.labelText]}
                        ucFirst={true}
                        text={'_%país%_'}
                        translate={true}
                      />
                      <div className={[classes.selectBox, classes.countryContainer].join(' ')}>
                        <SelectField
                          verifyInListSelected={true}
                          getOptionLabel={option => option.get('name')}
                          getOptionValue={option => option.get('alpha2')}
                          model={'customerCountry'}
                          validations={['required']}
                          innerStyle={[classes.nationalitySelector]}
                          defaultValue={this.defaultNationality}
                          options={countries}
                          styles={{
                            control: base => ({
                              ...base,
                              height: '100%',
                              border: 'none',
                              position: 'relative'
                            }),
                            SingleValue: base => ({
                              ...base,
                              height: '100%',
                              verticalAlign: 'middle'
                            }),
                            noOptionsMessage: base => ({
                              ...base,
                              textAlign: 'left',
                            }),
                            menu: base => {
                              return {
                                ...base,
                                zIndex: '10',
                                width: '100%'
                              };
                            },
                            menuList: base => {
                              return {
                                ...base,
                                width: 'auto',
                                overflowX: 'hidden',
                                maxHeight: '140px'
                              };
                            },
                            input: base => {
                              return {
                                ...base,
                                position: 'absolute'
                              };
                            },
                            valueContainer: base => {
                              return {
                                ...base,
                                height: '30px'
                              };
                            },
                            indicatorSeparator: base => {
                              return {
                                ...base,
                                display: 'none'
                              };
                            },
                            indicatorsContainer: base => {
                              return {
                                ...base,
                                position: 'absolute',
                                top: 0,
                                right: langCode !== 'AR' ? -4 : 'auto',
                                left: langCode !== 'AR' ? 'auto' : -4,
                                bottom: 0
                              };
                            },
                            dropdownIndicator: base => ({
                              ...base,
                              color: theme.themeValues.mainColor,
                              '&:hover': {
                                color: theme.themeValues.mainColor
                              }
                            })
                          }}
                        />
                      </div>
                    </label>
                  </>}
                  {/* city */}
                  {(hotelUS || this.tpvEnabled === 'Cardnet' ) &&
                    <label className={[classes.inputBox, showEditUserFields ? '' : classes.rightMargin].join(' ')}
                           ref={'customerCity'}>
                      <InputField
                        model={'customerCity'}
                        innerStyle={['inputText', classes.inputText]}
                        type={'text'}
                        validationsFields={{ field: 'ciudad' }}
                        validations={[
                          'required',
                          { type: 'minLength', minLength: 2 },
                          { type: 'maxLength', maxLength: 100 }
                        ]}
                      />
                      <InputNotify model={'customerCity'} />
                      <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%ciudad%_'} translate={true} />
                    </label>
                  }
                  {/* postCode */}
                  {(hotelUS || this.tpvEnabled === 'Cardnet' ) &&
                    <label className={[classes.inputBox, showEditUserFields ? '' : classes.rightMarginNo].join(' ')}
                           ref={'postCode'}>
                      <InputField
                        model={'postCode'}
                        innerStyle={['inputText', classes.inputText]}
                        type={'text'}
                        validationsFields={{ field: 'código postal' }}
                        validations={[
                          'required',
                          { type: 'minLength', minLength: 2 },
                          { type: 'maxLength', maxLength: 100 }
                        ]}
                      />
                      <InputNotify model={'postCode'} />
                      <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%código postal%_'}
                                translate={true} />
                    </label>
                  }
                  {showStateSelector &&
                    <label className={[classes.inputBox].join(' ')}>
                      <div className={classes.cityContainer}>
                        <RichText
                          innerStyle={[classes.citiesLabel, classes.labelText]}
                          ucFirst={true}
                          text={'_%ciudad%_'}
                          translate={true}
                        />
                        <div className={[classes.selectBox].join(' ')}>
                          <SelectField
                            getOptionLabel={option => option.get('name')}
                            getOptionValue={option => option.get('code')}
                            model={'state'}
                            innerStyle={[classes.citySelector]}
                            defaultValue={states.find(s => s.get('code') === currentState) || states.first()}
                            options={states}
                            styles={{
                              control: base => ({
                                ...base,
                                height: '100%',
                                border: 'none',
                                position: 'relative'
                              }),
                              SingleValue: base => ({
                                ...base,
                                height: '100%',
                                verticalAlign: 'middle'
                              }),
                              menu: base => {
                                return {
                                  ...base,
                                  zIndex: '10',
                                  width: '100%'
                                };
                              },
                              menuList: base => {
                                return {
                                  ...base,
                                  width: 'auto',
                                  overflowX: 'hidden',
                                  maxHeight: '140px'
                                };
                              },
                              input: base => {
                                return {
                                  ...base,
                                  position: 'absolute'
                                };
                              },
                              valueContainer: base => {
                                return {
                                  ...base,
                                  height: '30px'
                                };
                              },
                              indicatorSeparator: base => {
                                return {
                                  ...base,
                                  display: 'none'
                                };
                              },
                              indicatorsContainer: base => {
                                return {
                                  ...base,
                                  position: 'absolute',
                                  top: 0,
                                  right: langCode !== 'AR' ? -4 : 'auto',
                                  left: langCode !== 'AR' ? 'auto' : -4,
                                  bottom: 0
                                };
                              },
                              dropdownIndicator: base => ({
                                ...base,
                                color: theme.themeValues.mainColor,
                                '&:hover': {
                                  color: theme.themeValues.mainColor
                                }
                              })
                            }}
                          />
                        </div>
                      </div>
                    </label>}
                  <label className={[classes.inputBox, showEditUserFields ? '' : classes.rightMargin].join(' ')}>
                    <div className={classes.arrivingHours}>
                      <div className={classes.labelText}>
                        <RichText innerStyle={classes.hourslabel} text={'_%hora de llegada%_'} translate={true}
                                  ucFirst={true} />
                      </div>
                      <TooltipWrapper
                        popover={
                          <span className={[classes.ratePopover].join(' ')}>
                            <RichText text={'_%hora de la zona horaria del hotel%_'} translate={true} ucFirst={true} />
                            <br />
                            <RichText
                              text={
                                '_%no podemos garantizar que la habitación esté disponible cuando llegues, pero haremos lo posible por satisfacer la petición.%_'
                              }
                              translate={true}
                              ucFirst={true}
                            />
                          </span>
                        }
                        typeTooltip={'arrivingHoursToolTip'}
                        popoverStyle={classes.rateTooltip}
                        bottomLimit={100}
                        pointerStyle={[classes.tooltipPointerStyle, classes.tooltipArrinvingHour].join(' ')}
                        posX={'middle'}
                        posY={'top'}>
                        <div className={classes.infoFloatIcon}>
                          <Image svg={'infoIcon'} />
                        </div>
                      </TooltipWrapper>
                    </div>
                    <SelectField
                      getOptionLabel={option => option.label}
                      getOptionValue={option => option.value}
                      model={'hours_arrival'}
                      styles={hoursSelectStyle(theme.themeValues.mainColor)}
                      innerStyle={[classes.hoursSelector]}
                      defaultValue={this.defaultArrivalHour}
                      options={this.arrivingHoursList}
                      isSearchable={false}
                      components={{
                        SingleValue: ArrivingHoursOptions(this.arrivingHoursList, classes)
                      }}
                    />
                  </label>

                  <LoyaltyForm classes={classes} />

                  <div
                    className={classes.containerInfoTrip}>
                    <div className={classes.inputBox}>
                    <RichText
                      text={'_%¿Cuál es el motivo de tu viaje?%_'}
                      translate={true}
                      ucFirst={false}
                        innerStyle={ ['roboto13Black', classes.travelReasonContainer] }
                    />
                    <RadioGroupField
                      defaultValue={reservation.getIn(['customer', 'travel_reason'], false)}
                      model={'travel_reason'}
                        innerStyle={[classes.inputRadio]}
                      options={[
                        {
                          value: 'leisure',
                          text: 'ocio',
                          translate: true,
                          ucFirst: true,
                            innerStyle: ['roboto13Black']
                        },
                        {
                          value: 'business',
                          text: 'negocio',
                          translate: true,
                          ucFirst: true,
                            innerStyle: ['roboto13Black']
                        }
                      ]}
                    />
                  </div>
                    {managementGroupID === PROPERTY_MANAGEMENT_GROUP &&
                      <div className={classes.inputBox}>
                        <label className={[classes.checkBox, classes.oblig].join(' ')} ref={'required_policies'} onChange={this.toggleBookerGuest} >
                          <CheckboxField
                            defaultValue={this.state.showBookerGuestForm}
                            type={'checkbox'}
                            model={'booker_check'}
                            innerStyle={['inputCheck', classes.inputCheck]}
                            css={{ invalid: null, valid: null }}
                            id={'td-d3-booker-form-00'}
                          />
                          <RichText
                            text={'_%La reserva es para otra persona%_'}
                            translate={true}
                            ucFirst={false}
                            innerStyle={['roboto13Black', classes.travelReasonContainer]}
                          />
                        </label>
                </div>
                    }
                  </div>
                </div>
                {this.state.showBookerGuestForm && (
                  <><div className={classes.guestFormTitle}>
                    <RichText innerStyle={[classes.title, classes.noPadding]} ucFirst={true} text={'_%datos huésped%_'} translate={true} />
                  </div><div className={classes.guestForm}>
                      <label className={classes.inputBox} ref={'booker_name'}>
                        <InputField
                          model={'booker_name'}
                          defaultValue={reservation.getIn(['customer', 'guest_booker','booker_name'], '')}
                          innerStyle={['inputText', classes.inputText]}
                          autoFocus={true}
                          validationsFields={{ field: 'nombre' }}
                          validations={[
                            'required',
                            { type: 'maxLength', maxLength: 100 },
                            { type: 'minLength', minLength: 2 }
                          ]} />
                        <InputNotify model={'booker_name'} />
                        <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%nombre%_'} translate={true} />
                      </label>
                      <label className={classes.inputBox} ref={'booker_surname'}>
                        <InputField
                          model={'booker_surname'}
                          defaultValue={reservation.getIn(['customer', 'guest_booker','booker_surname'], '')}
                          innerStyle={['inputText', classes.inputText]}
                          validationsFields={{ field: 'apellidos' }}
                          validations={[
                            'required',
                            { type: 'minLength', minLength: 2 },
                            { type: 'maxLength', maxLength: 100 }
                          ]} />
                        <InputNotify model={'booker_surname'} />
                        <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%apellidos%_'}
                          translate={true} />
                      </label>
                      <label className={classes.inputBox} ref={'booker_email'}>
                        <InputField
                          model={'booker_email'}
                          defaultValue={reservation.getIn(['customer', 'guest_booker','booker_email'], '')}
                          innerStyle={['inputText', classes.inputText]}
                          validationsFields={{ field: 'email' }}
                          validations={[
                            'required',
                            'email',
                            {
                              type: 'compareField',
                              invalidText: '',
                              alterModel: 'booker_repeat_email',
                              alterField: 'repetir email'
                            }
                          ]}
                          type={'email'} />
                        <InputNotify model={'booker_email'} />
                        <RichText
                          innerStyle={[classes.labelText]}
                          ucFirst={true}
                          text={'_%email%_'}
                          translate={true} />
                      </label>
                      <label className={classes.inputBox} ref={'booker_repeat_email'}>
                        <InputField
                          model={'booker_repeat_email'}
                          defaultValue={reservation.getIn(['customer', 'guest_booker','booker_email'], '')}
                          innerStyle={['inputText', classes.inputText]}
                          validationsFields={{ field: 'repetir email' }}
                          validations={[
                            'required',
                            'email',
                            {
                              type: 'compareField',
                              alterModel: 'booker_email',
                              alterField: 'email'
                            }
                          ]}
                          type={'email'} />
                        <InputNotify model={'booker_repeat_email'} />
                        <RichText
                          innerStyle={[classes.labelText]}
                          ucFirst={true}
                          text={'_%repetir email%_'}
                          translate={true} />
                      </label>
                    </div></>
                )}

                {fullFreeReservation && directPayment ? null :
                  <div className={showTpvForm ? classes.paymentMethod : classes.hide}>
                    <RichText ucFirst={true} innerStyle={[classes.title, classes.noPadding]} translate={true}>
                      _%datos de pago%_
                    </RichText>
                    {hotelCountry === 'US' && managementGroupID === PROPERTY_MANAGEMENT_GROUP &&
                      <div className={this.tpvEnabled ? classes.cardImagesBoxTPV : classes.cardImagesBox}>
                        <Image alt={'mastercard_card_logo'} className={classes.cardLogo}
                               src={'/assets/images/mastercard_logo.png'} />
                        <Image alt={'visa_card_logo'} className={classes.cardLogo}
                               src={'/assets/images/visa_logo.png'} />
                        <Image alt={'american_express_card_logo'} className={classes.cardLogo}
                               src={'/assets/images/american_express_logo.png'} />
                        <Image alt={'diners_club_card_logo'} className={classes.cardLogo}
                               src={'/assets/images/diners_club_logo.png'} />
                        <Image alt={'union_pay_card_logo'} className={classes.cardLogo}
                               src={'/assets/images/union_pay_logo.png'} />
                      </div>}
                    <SelectPayForm
                      defaultValue={isBizum ? 'bizum' : reservationPayformCode}
                      reservationPaid={reservationPaid}
                      isBlackListed={blacklistedEmail}
                    />
                  </div>}
                {
                  <EPGContainer
                    tpvEnabled={this.tpvEnabled}
                    epgCashierContainer={this.EPG ? this.EPG.cashierContainer : null}
                    epgPrepayToken={this.EPG ? this.EPG.prepayToken : null}
                    payFormSelected={this.state.payFormSelected}
                    reservationPaid={reservationPaid}
                    UserLoggedST={UserLoggedST}
                  />
                }
                {this.amazonPayEnabled && <AmazonPayWidget
                  payFormSelected={this.state.payFormSelected}
                  setAmazonReferenceId={this.setAmazonReferenceId}
                />}

				        {(fullFreeReservation || this.STRIPE) ? null : <div
					        style={{ height: (parseInt(this.state.pciIframeHeight) + 30) + 'px' }}
					        className={
					        (payFormsWithPCI.includes(this.state.payFormSelected) || this.SIBS || UserLoggedST) && !reservationPaid ? classes.wrapperPciFrame : classes.hide
                  }>
                  <PciFrame
                    langCode={langCode}
                    trackingId={trackingId}
                    hotelCode={hotelCode}
                    checkinPCI={checkinPCI}
                    checkoutPCI={checkoutPCI}
                    showCVC={showCVC}
                    cfees15d={cfees15d}
                    tpvEnabled={hotel.getIn(['tpv', 'name'], false)}
                    withCof={PSD2Active}
                    requiredPrepayment={requiredPrepaymentCalc}
                    cardTokenId={this.paymentToken}
                    setRef={this.setPciFrameRef}
                    cardVerification={hotel.getIn(['pci', 'card_verification'], false)}
                  />
                </div>}

                {(!fullFreeReservation && isStripeHtl) ?  <div  className={
                  payFormsWithPCI.includes(this.state.payFormSelected) && !reservationPaid ? classes.cardHolderContainer : classes.hide
                }>

                  <div>
                    <RichText innerStyle={[classes.title,classes.promotionalCodeTitle]} translate={true} ucFirst={true}>
                      {'_%nombre del titular%_'}
                    </RichText>
                    <div>
                      <label className={classes.inputBox} ref={'card_holder'}>
                        <InputField
                          model={'card_holder'}
                          defaultValue={reservation.getIn(['customer', 'card_holder'], '')}
                          innerStyle={['inputText', classes.inputText]}
                        />
                        {!this.state.cardHolderError.error && (
                          <InputNotify model={'card_holder'}/>
                        )}
                        {this.state.cardHolderError.error && (
                          <RichText translate={true} ucFirst={true} innerStyle={[classes.promotionCodeError]} text={this.state.cardHolderError.text}/>
                        )}
                        <RichText innerStyle={[classes.labelTextTitle]} text={'_%nombre del titular%_'} ucFirst={true} translate={true}/>
                      </label>
                    </div>
                  </div>
                </div> : null}

                {(!fullFreeReservation && isStripeHtl && stripeToken) ?  <div  className={
                  payFormsWithPCI.includes(this.state.payFormSelected) && !reservationPaid ? classes.wrapperPciFrame : classes.hide
                }>
                  <Elements stripe={stripePromise} options={stripeOptions}>
                    <StripeFrame callbackRegister={this.paymentCallbackRegister} hotelId={hotelId} tracking={trackingId} hotelCode={hotelCode}/>
                  </Elements>
                </div> : null}

                {this.state.showCardValidationError && (
                  <div className={classes.errorPCI} ref={'card_validation_error'}>
                    <RichText
                      text={
                        '_%ha ocurrido un error con tu tarjeta. Comprueba que los datos introducidos sean correctos.%_'
                      }
                      translate={true}
                      innerStyle={['errorForm15']}
                      ucFirst={true}
                    />
                  </div>
                )}


                <div className={classes.commentSection}>
                  <div className={classes.relativeFoldContainer}>
                    <RichText ucFirst={true} innerStyle={[classes.title, classes.noPadding, classes.noMargin]}
                              translate={true}>
                      _%Comentario o petición (opcional)%_
                    </RichText>
                    <Button
                      innerStyle={[classes.roomToggle, this.state.editCommentary ? classes.up : classes.down]}
                      onClick={this.toggleAdditionalCommentary}
                      ariaLabel={'_%Comentario o petición (opcional)%_'}
                      translate={true}
                      rightIcon={{
                        unicodeContent: 'E052',
                        innerStyle: [classes.searchOptionsButtonIconOpen, this.state.editCommentary ? classes.up : classes.down]
                      }}
                    />
                  </div>
                  <div ref={this.setInnerRef} className={classes.relativeFoldCommentaryAnimation}
                      onTransitionEnd={() => this.updateAfterTransition()}
                      style={{ height: this.state.heightContainer }}>
                    <div className={classes.relativeFoldCommentaryContainer}>
                      {hotelPreferences && !!hotelPreferences.size && (
                        <RoomPreferences
                          blocks={blocks}
                          sections={sections}
                          rooms={reservation.get('rooms')}
                          hotelPreferences={hotelPreferences}
                          showRoomPreferences={this.state.showRoomPreferences}
                          langCode={langCode}
                          toggleRoomPreferences={this.toggleRoomPreferences}
                          onChange={this.onChange}
                          onBlur={this.onBlur}
                        />
                      )}
                      <label className={[classes.inputBox, classes.textAreaBox].join(' ')}>
                        <div className={classes.containerAreaComment}>
                          <TextAreaField
                            model={'notes'}
                            innerStyle={[classes.inputText]}
                            defaultValue={reservation.getIn(['customer', 'notes'], '')}
                          />
                          <RichText
                            ucFirst={true}
                            innerStyle={[classes.labelText]}
                            text={'_%añadir comentarios%_'}
                            translate={true}
                          />
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
                {!(hidePromotionCode && !gift_voucher) ?
                  <div className={classes.promotionCodContainer}>
                    <div className={classes.relativeFoldContainer}>
                      <RichText ucFirst={true} innerStyle={[classes.title, classes.noPadding, classes.noMargin]}
                                translate={true}>
                        _%Añadir cupón%_
                      </RichText>
                      <Button
                        innerStyle={[classes.roomToggle, this.state.showPromotionalBox ? classes.up : classes.down]}
                        onClick={this.togglePromotionalCode}
                        ariaLabel={'_%Añadir cupón%_'}
                        translate={true}
                        rightIcon={{
                          unicodeContent: 'E052',
                          innerStyle: [classes.searchOptionsButtonIconOpen, this.state.showPromotionalBox ? classes.up : classes.down]
                        }}
                      />
                    </div>
                    <CSSTransition
                      in={this.state.showPromotionalBox}
                      timeout={290}
                      classNames={{
                        enter: classes.promotionalCodeEnter,
                        enterActive: classes.promotionalCodeEnterActive,
                        exit: classes.promotionalCodeLeave,
                        exitActive: classes.promotionalCodeLeaveActive
                      }}>
                      {state => (
                        <div
                          //onClick={e => e.stopPropagation()}
                          style={state === 'exited' ? {
                            visibility: 'hidden',
                            opacity: '0',
                            height: '0',
                            paddingBottom: '0',
                            overflow: 'hidden'
                          } : { visibility: 'visible', opacity: '1' }}
                          className={[classes.promotionalCodeContainer].join(' ')}>
                          <div className={classes.promotionalCodeOverflow}>
                            {hidePromotionCode ? '' : <PromotionCodeForm type={'promotion_code'}/>}
                            {gift_voucher ? <PromotionCodeForm type={'gift_voucher'}/> : ''}
                          </div>
                        </div>
                      )}
                    </CSSTransition>
                  </div>
                  : ''
                }
                {this.travelClubEnabled && ipTravelClub?
                  <div className={classes.travelClubContainer}>
                    <div className={classes.commentSection}>
                      <RichText ucFirst={true} innerStyle={[classes.title, classes.noPadding, classes.noMargin]} translate={true}>
                        _%Travel Club%_
                      </RichText>
                      <Button
                        innerStyle={[classes.roomToggle, this.state.showTravelClub ? classes.down: classes.up ]}
                        onClick={this.toggleTravelClub}
                        ariaLabel={'_%travel club%_'}
                        translate={true}
                        rightIcon={{
                          unicodeContent: 'E052',
                          innerStyle: [classes.searchOptionsButtonIconOpen, this.state.showTravelClub  ? classes.down : classes.up]
                        }}
                      />
                      <CSSTransition
                        in={this.state.showTravelClub}
                        timeout={290}
                        classNames={{
                            enter: classes.promotionalCodeEnter
                         /* enterActive: classes.promotionalCodeEnterActive, */
                          /* exit: classes.promotionalCodeLeave,
                          exitActive: classes.promotionalCodeLeaveActive  */
                        }}>
                        {state => (
                          <div
                            //onClick={e => e.stopPropagation()}
                            style={state === 'entered' ? {
                              visibility: 'hidden',
                              opacity: '0',
                              height: '0',
                              paddingBottom: '0',
                              overflow: 'hidden'
                            } : { visibility: 'visible', opacity: '1' }}
                              className={[classes.travelClubCards].join(' ')}>
                            <div>
                              <RichText ucFirst={true} innerStyle={['roboto13BoldBlack', 'travelclub_text']} translate={true}>
                                _%si eres socio Travel Club, introduce los 10 últimos dígitos de tu tarjeta y acumula puntos con esta reserva.%_
                              </RichText>
                              <label className={classes.inputBox} ref={'travelclub_card'}>
                                <InputField
                                  model={'travelclub_card'}
                                  defaultValue={reservation.getIn(['travelclub', 'travelclub_card'], '')}
                                  innerStyle={['inputText', classes.inputText, 'travelclub_card']} />
                                {this.state.travelclubError.validCheck && (
                                  <InputNotify model={'travelclub_card'} />
                                )}
                                <RichText innerStyle={[classes.labelText, 'capitalize']} text={'6015470 |'} translate={true} />
                                {this.state.travelclubError.error && (
                                  <RichText translate={true} ucFirst={true} innerStyle={[classes.promotionCodeError]} text={this.state.travelclubError.text} />
                                )}
                              </label>
                            </div>
                            {ipTravelClub ?
                              <div className={classes.travelCards}>
                                <Image innerStyle={'backgroundImageBase'} backgroundImage={'../assets/images/travelclub_cards.png'} />
                              </div>
                            :
                              <div className={classes.travelClubAltLogoCont}>
                                <Image svg={'travelClubAltLogo'} alt={'travel club'} innerStyle={classes.travelClubAltLogo} />
                                <div className={classes.travelClubTextContainer}>
                                  <RichText text={'_%acumula puntos%_'} innerStyle={['roboto13Gray']} ucFirst={true} translate={true} />
                                  <span className={classes.travelClubText}>travel<RichText text={'_%club%_'} innerStyle={['roboto14Gray']} ucFirst={true} translate={true} /></span>
                                </div>
                              </div>
                            }
                          </div>
                        )}
                      </CSSTransition>
                    </div>
                  </div> : ''
                }
                {showLoyaltyPaymentPoints ?
                  <div className={classes.promotionCodContainer}>
                    <div className={classes.relativeFoldContainer}>
                      <RichText ucFirst={true} innerStyle={[classes.title, classes.noPadding, classes.noMargin]}
                                translate={true}>
                        _%Pagar con puntos Star Traveler%_
                      </RichText>
                      <Button
                        innerStyle={[classes.roomToggle, this.state.showLoyaltyPaymentPoints ? classes.up : classes.down]}
                        onClick={this.toggleLoyaltyPaymentPoints}
                        ariaLabel={'_%Pagar con puntos Star Traveler%_'}
                        translate={true}
                        rightIcon={{
                          unicodeContent: 'E052',
                          innerStyle: [classes.searchOptionsButtonIconOpen]
                        }}
                      />
                    </div>
                    <CSSTransition
                      in={this.state.showLoyaltyPaymentPoints}
                      timeout={290}
                      classNames={{
                        enter: classes.promotionalCodeEnter,
                        enterActive: classes.promotionalCodeEnterActive,
                        exit: classes.promotionalCodeLeave,
                        exitActive: classes.promotionalCodeLeaveActive
                      }}>
                      {state => (
                        <div
                          //onClick={e => e.stopPropagation()}
                          style={state === 'exited' ? {
                            visibility: 'hidden',
                            opacity: '0',
                            height: '0',
                            paddingBottom: '0',
                            overflow: 'hidden'
                          } : { visibility: 'visible', opacity: '1' }}
                          className={[classes.promotionalCodeContainer].join(' ')}>
                          <div className={classes.promotionalCodeOverflow}>
                            <LoyaltyPaymentPoints />
                          </div>
                        </div>
                      )}
                    </CSSTransition>
                  </div>
                  : ''
                }
                <div className={classes.acceptBoxes}>
                  <LoyaltyPoliciesChecks
                    classes={classes}
                    group={hotel.get('group', '')}
                    penalties={penalties}
                    requiredPrepaymentText={requiredPrepaymentText}
                  />
                  <label className={[classes.checkBox, classes.oblig].join(' ')} ref={'required_policies'}>
                    <CheckboxField
                      defaultValue={reservation.getIn(['customer', 'required_policies'], false)}
                      type={'checkbox'}
                      validations={['required']}
                      validationsFields={{ field: '' }}
                      model={'required_policies'}
                      innerStyle={['inputCheck', classes.inputCheck]}
                      css={{ invalid: null, valid: null }}
                        tabIndex={0}
                      ariaLabel={'_%acepto las condiciones de tarifa%_'}
                    />
                    <PolicyModalGroup group={hotel.get('group', '')} penalties={penalties} requiredPrepaymentText={requiredPrepaymentText}/>

                  </label>
                </div>
                {dataControllerText && <div className={classes.legalTextContainer}>
                  <RichText dangerouslySetInnerHTML={dataControllerText} innerStyle={['roboto11Black400']} ucFirst={true}/>
                </div>}
                <div className={classes.finalPrice}>
                  <div className={classes.tableContainer}>
                    <div className={classes.tableCell}  tabIndex={0}>
                      <RichText text={'_%precio total%_'} innerStyle={['totalPrice']} ucFirst={true} translate={true}/>
                      <TaxIncluded showTaxes={showTaxes}/>
                    </div>
                    <div className={classes.tableCell} tabIndex={0}>
                      <OldPrice amount={totalPrice} discountPercent={discountPercent} discountAmount={discountAmount}/>
                      <Price innerStyle={['summaryPriceBig']} amount={endTotalPrice}/>
                      <EquivalentPrice
                        hotelCurrencyCode={hotelCurrencyCode}
                        currentCurrencyCode={currentCurrencyCode}
                        totalPrice={amountToPay}
                      />
                    </div>
                    <div className={classes.buttonContainer}>
                      {this.state.payFormSelected !== 'paypal' && this.state.payFormSelected !== 'amazon_pay' &&
                      <ButtonSubmit
                        id={this.GtmId}
                        richText={{
                          text: '_%confirmar reserva%_',
                          translate: true,
                          ucFirst: true,
                          innerStyle: ['toggleSecondButton', 'notClickable'],
                          rightIcon: {
                            unicodeContent: config.langCode === 'AR' ? '005C' : 'e000',
                            innerStyle: ['size12', 'absoluteButton', 'notClickable']
                          }
                        }}
                        innerStyle={['toggleSecondButton', classes.robotoBtn]}
                      />}
                      {this.amazonPayEnabled && <AmazonPayButton
                        payFormSelected={this.state.payFormSelected}
                        langCode={this.props.config.langCode.toLowerCase()}
                      />}
                      {this.payPalEnabled && <PayPalContainer
                        payFormSelected={this.state.payFormSelected}
                        PayPal={this.PayPal}
                        setPayPalOrderId={this.setPayPalOrderId}
                        showErrorNotification={showErrorNotification}
                        langCode={langCode}
                      />}
                    </div>
                  </div>
                </div>
                {cityTax && <div className={classes.taxesContainer}>
                  <RichText dangerouslySetInnerHTML={cityTax} innerStyle={['roboto11Black400']}/>
                  {hotelCountry === 'US' && managementGroupID === PROPERTY_MANAGEMENT_GROUP &&
                    <div className={classes.hotelFiscalInfoContainer}>
                      <RichText dangerouslySetInnerHTML={`${hotel.get('address', '')} ${hotel.get('country', '')} ${hotel.get('zip_code', '')}, ${hotel.get('city')}`} innerStyle={['roboto11Black400']}/>
                      <RichText dangerouslySetInnerHTML={hotel.get('phone', '')} innerStyle={['roboto11Black400']}/>
                      <RichText dangerouslySetInnerHTML={hotel.get('email', '')} innerStyle={['roboto11Black400']}/>
                    </div>}
                </div>}
                {legalText && <div className={classes.legalTextContainer}>
                  <RichText dangerouslySetInnerHTML={legalText} innerStyle={['roboto11Black400']}/>
                </div>}
              </Form>
            </div>

          </div>
          <div className={classes.summaryContainer}>
            <AvailMainSideSummary forceHideRedeemPoints={this.state.showBookerGuestForm}/>
          </div>
        </div>
      </div>
    );
  }
};

const mapDispatchToProps = (dispatch, ownProps, state) => {
  const { reservation } = ownProps;
  return {
    saveCustomerData: (validForm, inputList,model,showBookerGuestForm) => {
      //const validationFields = ['email', 'repeatEmail'];
      //if (validationFields.every(field => inputList[field] && inputList[field].validation.valid)) {
        var requiredFields = ['email', 'repeatEmail'];
        if(showBookerGuestForm) requiredFields.push('booker_email');

        return dispatch(customerActions.reservation.patchAsync(customerPatchFields, inputList, { extraFields: true, requiredFields: requiredFields }));
      //}
      //return Promise.resolve();
    },
    changeRoomPreferences: (blockIdx, inputList) => {
      dispatch(customerActions.reservation.patchAsync('preferences', inputList, { blockIdx, callbackByField: false }));
    },
    changePayForm: (validForm, inputList, tpvCode, extraParams, paymentToken) => {
      // Aquesta validació ens està donant problemes, probo a comentar-la per veure com es comporta.
      //  const validationFields = ['email', 'repeatEmail'];
      //  if (
      //    validationFields.every(
      //      field => inputList[field] && inputList[field].validation && inputList[field].validation.valid
      //    )
      //  ) {
      let paymentObj = {};
      if (tpvCode) {
        paymentObj = Object.assign(paymentObj, { tpvCode: tpvCode });
      }
      if (extraParams) {
        paymentObj = Object.assign(paymentObj, extraParams);
      }
      if (paymentToken) {
        paymentObj = Object.assign(paymentObj, { paymentToken: paymentToken });
      }
      return dispatch(customerActions.reservation.patchAsync('payment', inputList, paymentObj));
      //  }
    },
    confirmBooking: (inputList, paymentToken, amountPaid) => {
      //validació per si les mosques, no hauria de ser necessari
      const logger = loggerGetter();

      const validationFields = ['email', 'repeatEmail'];
      if (
        validationFields.every(field => inputList[field] && inputList[field].validation.valid && inputList[field].value)
      ) {
        logger.addLine('confirm booking', 'ok');
        return dispatch(
          customerActions.reservation.patchAsync(bookingPatchFields, inputList, {
            paymentToken,
            extraFields: true,
            fromSuccessCof: true,
            payed : !!amountPaid
          })
        ).catch((e) => {
          if (e.name === 409) {
            dispatch(actions.avail.resetAvail());
            dispatch(actions.availServices.resetAvail());
            dispatch(actions.customer.step.change('monoHotelAvail'));
            dispatch(actions.router.update(true));
          }
        });
      } else {
        logger.addLine('confirm booking', 'reject no valid fields email repeatEmail');
        return Promise.reject();
      }
    },
    confirmBookingOnlyStore: () => {
      dispatch(customerActions.reservation.set(reservation.set('status', 'confirmed')));
    },
    incrementPaymentRetry: (nRetry) => {
      dispatch(customerActions.reservation.set(reservation.setIn(['payment', 'n_retry'], nRetry)));
    },
    confirmBookingEPG: (inputList, payed, hotelId, trackingId, tpvId, tpvCode, paymentToken, nRetry) => {
      //validació per si les mosques, no hauria de ser necessari
      const validationFields = ['email', 'repeatEmail'];
      if (
        validationFields.every(
          field => inputList[field] && inputList[field].validation.valid && inputList[field].value
        ) &&
        reservation.get('tracking_id') === trackingId
      ) {
        return dispatch(
          customerActions.reservation.patchAsync(bookingPatchFields, inputList, {
            paymentToken: paymentToken,
            payed: payed,
            merchantTransactionId: `${hotelId}-${trackingId}-${nRetry}`,
            tpvId: tpvId,
            tpvCode: tpvCode,
            TPVnRetry: nRetry,
            extraFields: true
          })
        );
      } else {
        return Promise.reject();
      }
    },
    confirmBookingRedsys: (inputList, payed, hotelId, trackingId, tpvId, tpvCode) => {
      //validació per si les mosques, no hauria de ser necessari
      const validationFields = ['email', 'repeatEmail'];
      if (
        validationFields.every(
          field => inputList[field] && inputList[field].validation.valid && inputList[field].value
        ) &&
        reservation.get('tracking_id') === trackingId
      ) {
        return dispatch(
          customerActions.reservation.patchAsync(bookingPatchFields, inputList, {
            payed: payed,
            merchantTransactionId: `${hotelId}-${trackingId}`,
            tpvId: tpvId,
            tpvCode: tpvCode,
            extraFields: true
          })
        );
      } else {
        return Promise.reject();
      }
    },
    confirmBookingXpay: (inputList, payed, hotelId, trackingId, tpvId, tpvCode) => {
      //validació per si les mosques, no hauria de ser necessari
      const validationFields = ['email', 'repeatEmail'];
      if (
        validationFields.every(
          field => inputList[field] && inputList[field].validation.valid && inputList[field].value
        ) &&
        reservation.get('tracking_id') === trackingId
      ) {
        return dispatch(
          customerActions.reservation.patchAsync(bookingPatchFields, inputList, {
            payed: payed,
            merchantTransactionId: `${hotelId}-${trackingId}`,
            tpvId: tpvId,
            tpvCode: tpvCode,
            extraFields: true
          })
        );
      } else {
        return Promise.reject();
      }
    },
    confirmBookingPaycomet: (inputList, payed, hotelId, trackingId, tpvId, tpvCode) => {
      //validació per si les mosques, no hauria de ser necessari
      const validationFields = ['email', 'repeatEmail'];
      if (
        validationFields.every(
          field => inputList[field] && inputList[field].validation.valid && inputList[field].value
        ) &&
        reservation.get('tracking_id') === trackingId
      ) {
        return dispatch(
          customerActions.reservation.patchAsync(bookingPatchFields, inputList, {
            payed: payed,
            merchantTransactionId: `${hotelId}-${trackingId}`,
            tpvId: tpvId,
            tpvCode: tpvCode,
            extraFields: true
          })
        );
      } else {
        return Promise.reject();
      }
    },
    confirmBookingStripe: (inputList, payed, hotelId, trackingId, tpvId, tpvCode) => {
      //validació per si les mosques, no hauria de ser necessari
      const validationFields = ['email', 'repeatEmail'];
      if (
        validationFields.every(
          field => inputList[field] && inputList[field].validation.valid && inputList[field].value
        ) &&
        reservation.get('tracking_id') === trackingId
      ) {
        return dispatch(
          customerActions.reservation.patchAsync(bookingPatchFields, inputList, {
            payed: payed,
            merchantTransactionId: `${hotelId}-${trackingId}`,
            tpvId: tpvId,
            tpvCode: tpvCode,
            extraFields: true
          })
        );
      } else {
        return Promise.reject();
      }
    },
    cancelBooking: (inputList) => {
      return dispatch(customerActions.reservation.patchAsync(bookingPatchFields, inputList, { cancelReservation: true }));
    },
    showConfirmation: (reservation, hotel) => {
      //dispatch(actions.events.trigger('confirm_customer_data'));
      dispatch(actions.customer.step.next());
      const logger = loggerGetter();
      logger
        .cancelSend()
        .clearLog()
        .sendIfErrors('confirmation completed', reservation.get('tracking_id'));
      dispatch(actions.router.update());
      return true;
    },
    showErrorNotification: text => {
      dispatch(actions.notifications.send('error', text));
      window.document.body.scrollTop = window.document.documentElement.scrollTop = 0;
    },
    setReservationPayed: (reservation, showTaxes) => {
      dispatch(
        customerActions.reservation.set(
          reservation
            .set('status', 'confirmed')
            .setIn(['payment', 'state'], 'payed')
            .setIn(['payment', 'amount_paid'], reservation.get(showTaxes ? 'total_price_tax' : 'total_price'))
            .setIn(['payment', 'amount_pending'], 0)
        )
      );
      return true;
    },
    setReservationToken: (reservation, token) => {
      dispatch(
        customerActions.reservation.set(reservation.setIn(['payment', 'token'], token))
      );
      return true;
    },
    triggerEvent: (name, error) => {
      dispatch(actions.events.trigger(name, { error }));
    },
    hideAvailEngine: () => {
      dispatch(customerActions.header.show('engine', false));
    },
    setStripeToken: (currency, lang, price, hotelCode, trackingId, redirectUrl,force = false) => {
      dispatch(customerActions.stripeToken.getAsync(currency, lang, price, hotelCode, trackingId, redirectUrl, force));
      return true;
    },
    setPayformOP: (inputList) => {
      dispatch(
        customerActions.reservation.patchAsync('payment', inputList, {
          forcePayformOP : true
        })
      );
      dispatch(customerActions.reservation.set(reservation.setIn(['payment', 'payform_code'], 'op')));
      return true;
    },
    loyaltyRegister: (inputList) => {
      return dispatch(
        actions.customer.loyalty.register(inputList)
      );
    },
    loyaltyLogin: (inputList) => {
      dispatch(
        actions.customer.loyalty.login(inputList)
      );
      return true;
    }
  };
};

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  let hotelInfo = store.getIn(['hotels', hotelId]);
  hotelInfo = is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo;
  const loyaltyRoomsAvail = store.getIn([
    'avail',
    hotelId,
    store.getIn(['hotels', hotelId, 'params', 'string_loyalty_query_params']),
    'response'
  ],false);
  const roomRatesSelected = store.getIn(['customer', 'reservation_request']);
  const reservation = store.getIn(['customer', 'reservation']);
  const reservationBlocks = store.getIn(['customer', 'reservation_request', 'blocks']);
  const queryParams = store.getIn(['hotels', hotelId, 'params', 'query_params']);
  const checkin = queryParams && moment(queryParams.get('date'));
  const stayLength = queryParams && queryParams.get('stay_length');
  const blocks = store.getIn(['customer', 'reservation_request', 'blocks']);
  const tpvPaymentStatus = hashSpliter(window.location.hash)[3] || false;
  const stripeStatus = hashSpliter(window.location.hash)[4] || false;
  const amountPromoPaid = reservation.getIn(['payment', 'amount_promo_paid'], 0);
  const amazonPayEnabled = hotelInfo && hotelInfo.getIn(['amazon_pay', 'name'], false);
  const amazonPayParams = amazonPayEnabled && hotelInfo && hotelInfo.getIn(['amazon_pay', 'tpv_params'], List());
  const amazonPayMerchantID = amazonPayParams && amazonPayParams.find(p => p.get('code') === 'merchant_id', Map()).get('value', '');
  const withTaxes = hotelInfo && hotelInfo.get('show_taxes', true);
  let blacklistedEmails = hotelInfo && hotelInfo.get('blacklist_emails', false);
  blacklistedEmails = blacklistedEmails && blacklistedEmails.map(emailB64 =>decodeBlackEmail(emailB64, hotelId));
  const amountTaxes = withTaxes ? reservation.get('total_price_tax', 0) : reservation.get('total_price', 0);
  const directPayment = hotelInfo && hotelInfo.getIn(['payment_info', 'direct_payment'], true);
  let fullFreeReservation = store.getIn(['customer', 'reservation', 'penalties', 0], false);
  const profileType = store.getIn(['customer', 'corporate', 'tipo_perfil'], false);
  const tpvEnabled = hotelInfo && !(hotelInfo.getIn(['tpv_only_gift_voucher'], false)) ? hotelInfo.getIn(['tpv', 'name'], false) : false;
  const loyaltyUser = store.getIn(['customer', 'loyalty','user',"user_id"], null) && store.getIn(['customer', 'loyalty','user'], null);
  const loyaltyType = store.getIn(["customer", "loyalty", "data", "loyalty", "code"],null);
  const UserLoggedST = !!loyaltyUser && loyaltyType === STAR_TRAVELER_CODE;

  if (fullFreeReservation) {
    fullFreeReservation = (fullFreeReservation.get('release', null) === 23976 && fullFreeReservation.get('type', null) === 'percentage'
      && fullFreeReservation.get('value', null) === 0 && fullFreeReservation.get('show_as', null) === 'days');
  }


  const isNotFinallyConfirmed = !(
    reservation.get('status', false) === 'confirmed' &&
    !(
      !UserLoggedST &&
      (['op', 'amazon_pay'].includes(reservation.getIn(['payment', 'payform_code'], false))) &&
      reservation.getIn(['payment', 'state'], false) === 'pending'
    )
  );

  let requiredPrepayment = 0;
  let requiredPrepaymentType = false;
  let requiredPrepaymentValue = false;
  reservation && reservation.get('blocks', List()).forEach(block => {
    requiredPrepayment += block.get('required_prepayment', 0);
    if (!requiredPrepaymentType) {
      requiredPrepaymentType = block.get('required_prepayment_type', '');
      requiredPrepaymentValue = block.get('required_prepayment_value', 0);
    }
  });
  const totalPointsPrice = reservation?.getIn(["loyalty", "total_points_price"], 0);

  let reservationEmail = reservation.getIn(['customer', 'email'], false);
  let forceOP = false;
  if(tpvEnabled && blacklistedEmails && blacklistedEmails.includes(reservationEmail)) {
    forceOP = true;
  }

  // let promoCodeDiscount = null;
  // let promoCode;
  // let giftCode = null;
  let giftCodeDiscount = 0;
  if (amountPromoPaid > 0 && reservation.getIn(['gift_voucher', 'code'], '') !== '') {
    giftCodeDiscount = amountPromoPaid * -1;
  }
  return {
    hotel: hotelInfo,
    reservation: reservation.size > 0 && isNotFinallyConfirmed ? reservation : undefined,
    reservationTotals:
      reservationBlocks && is(List, reservationBlocks) && reservationBlocks.size > 0 && getReservationTotals(store),
    langCode: store.getIn(['customer', 'lang_info', 'code']).toUpperCase(),
    checkin: checkin,
    stayLength: stayLength,
    defaultCountryCode: store.getIn(['customer', 'currencyCountry', 'country', 'code'], 'ES'),
    hotelPreferences: cleanHotelPreferences(store.getIn(['hotels', hotelId, 'preferences'], List())),
    countries: store.get('countries'),
    blocks: blocks && !blocks.some(block => block.get('room_id', false) === false) ? blocks : undefined,
    sections: store.getIn(['customer', 'reservation', 'sections']),
    corporatePayForms: store.getIn(['customer', 'corporate', 'pay_forms'], List()),
    tpvPaymentStatus: tpvPaymentStatus,
    cfees15d: reservation.size > 0 ? hasCancellationFeesIn15Days(reservation) : false,
    showTaxes: is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo.get('show_taxes', true),
    managementGroupID: is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo.get('management_group_id'),
    reservationPaid: reservation.get('total_price_tax', false) > 0 && reservation.get('total_price_tax', false) === reservation.getIn(['payment', 'amount_promo_paid'], false),
    amountToPay: amountTaxes - amountPromoPaid - totalPointsPrice,
    gift_voucher: store.getIn(['hotels', hotelId, 'gift_voucher']) ? store.getIn(['hotels', hotelId, 'gift_voucher']) : false,
    giftCodeDiscount: giftCodeDiscount,
    amazonPayMerchantID: amazonPayMerchantID,
    directPayment: directPayment,
    fullFreeReservation: fullFreeReservation,
    referer: store.getIn(['customer', 'params', 'url_params', 'id_referer'], false),
    requiredPrepayment: requiredPrepayment,
    requiredPrepaymentType: requiredPrepaymentType,
    requiredPrepaymentValue: requiredPrepaymentValue,
    //Currencies
    currencies: store.getIn(['customer', 'currencies']),
    langInfo: store.getIn(['customer', 'lang_info']),
    currentCurrencyCode: store.getIn(['customer', 'current_currency']) || undefined,
    hotelCurrencyCode: store.getIn(['hotels', hotelId, 'currency', 'code']),
    profileType: profileType,
    stripeToken: store.getIn(['customer', 'stripe_token'],false) || false,
    stripeTokenStatus: stripeStatus,
    loyaltyRoomsAvail: loyaltyRoomsAvail,
    loyaltySelected: !!loyaltyRoomsAvail && roomRatesSelected.get('loyalty', false),
    loyaltyUser: loyaltyUser,
    loyaltyType : loyaltyType,
    ipCountry: store.getIn(['customer','country_ip'],false),
    forceOP: forceOP,
    loyaltyCheckboxChecked: reservation.getIn(['customer', 'check_loyalty'], false),
    customerCountry: store.getIn(['customer','country', 'code'],false),
    blacklistedEmails,
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps, /*['reservation', 'blocks', 'sections','trackingId']*/[], LoadingFragment),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  showPopover,
  PropertyManager([
    'hotel',
    'blocks',
    'changePayForm',
    'changeRoomPreferences',
    'checkin',
    'confirmBooking',
    'confirmBookingOnlyStore',
    'confirmBookingEPG',
    'confirmBookingRedsys',
    'confirmBookingPaycomet',
    'confirmBookingXpay',
    'confirmBookingStripe',
    'cancelBooking',
    'corporatePayForms',
    'countries',
    'currentCurrencyCode',
    'defaultCountryCode',
    'hotelCurrencyCode',
    'hotelPreferences',
    'langCode',
    'reservation',
    'reservationTotals',
    'saveCustomerData',
    'sections',
    'showConfirmation',
    'stayLength',
    'tpvPaymentStatus',
    'showErrorNotification',
    'setReservationPayed',
    'setReservationToken',
    'triggerEvent',
    'cfees15d',
    'showTaxes',
    'managementGroupID',
    'hideAvailEngine',
    'reservationPaid',
    'amountToPay',
    'gift_voucher',
    'amazonPayMerchantID',
    'incrementPaymentRetry',
    'fullFreeReservation',
    'directPayment',
    'referer',
    'currencies',
    'langInfo',
    'requiredPrepayment',
    'requiredPrepaymentType',
    'requiredPrepaymentValue',
    'profileType',
    'setStripeToken',
    'stripeToken',
    'stripeTokenStatus',
    'loyaltyRoomsAvail',
    'loyaltySelected',
    'loyaltyUser',
    'loyaltyType',
    'ipCountry',
    'forceOP',
    'setPayformOP',
    'loyaltyRegister',
    'loyaltyLogin',
    'loyaltyCheckboxChecked',
    'customerCountry',
    'giftCodeDiscount',
    'closeByFamily',
    'toggleModal',
    'blacklistedEmails'
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent(['i18n','countryFlags'])
)(CustomerForm);
